export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		randomBattleMoves: ["gigadrain", "leechseed", "sleeppowder", "sludgebomb", "substitute"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerfire", "hiddenpowerice", "powerwhip", "protect", "sleeppowder", "sludgebomb"],
		tier: "RU",
		doublesTier: "DOU",
	},
	venusaurmega: {
		randomBattleMoves: ["earthquake", "gigadrain", "hiddenpowerfire", "leechseed", "sludgebomb", "synthesis"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerfire", "hiddenpowerice", "powerwhip", "protect", "sleeppowder", "sludgebomb"],
		tier: "OU",
		doublesTier: "DOU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		randomBattleMoves: ["airslash", "earthquake", "fireblast", "roost", "willowisp"],
		randomDoubleBattleMoves: ["airslash", "dragonpulse", "fireblast", "heatwave", "overheat", "protect", "roost", "tailwind"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	charizardmegax: {
		randomBattleMoves: ["dragonclaw", "dragondance", "earthquake", "flareblitz", "roost", "willowisp"],
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "earthquake", "flareblitz", "rockslide", "roost", "substitute"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	charizardmegay: {
		randomBattleMoves: ["airslash", "dragonpulse", "fireblast", "focusblast", "roost", "solarbeam"],
		randomDoubleBattleMoves: ["airslash", "fireblast", "focusblast", "heatwave", "protect", "roost", "solarbeam"],
		tier: "OU",
		doublesTier: "DOU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		randomBattleMoves: ["dragontail", "icebeam", "rapidspin", "roar", "scald", "toxic"],
		randomDoubleBattleMoves: ["fakeout", "followme", "hydropump", "icebeam", "icywind", "muddywater", "protect", "scald", "waterspout"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	blastoisemega: {
		randomBattleMoves: ["aurasphere", "darkpulse", "hydropump", "icebeam", "rapidspin", "scald"],
		randomDoubleBattleMoves: ["aurasphere", "darkpulse", "fakeout", "followme", "hydropump", "icebeam", "icywind", "muddywater", "protect", "scald"],
		tier: "UU",
		doublesTier: "DUU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		randomBattleMoves: ["bugbuzz", "energyball", "psychic", "quiverdance", "sleeppowder"],
		randomDoubleBattleMoves: ["bugbuzz", "protect", "psychic", "quiverdance", "shadowball", "sleeppowder", "substitute"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		randomBattleMoves: ["endeavor", "knockoff", "poisonjab", "tailwind", "toxicspikes", "uturn"],
		randomDoubleBattleMoves: ["brickbreak", "drillrun", "knockoff", "poisonjab", "protect", "stringshot", "uturn", "xscissor"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	beedrillmega: {
		randomBattleMoves: ["drillrun", "knockoff", "poisonjab", "swordsdance", "uturn", "xscissor"],
		randomDoubleBattleMoves: ["drillrun", "knockoff", "poisonjab", "protect", "substitute", "uturn", "xscissor"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		randomBattleMoves: ["bravebird", "defog", "heatwave", "return", "roost", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "doubleedge", "heatwave", "protect", "return", "tailwind", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pidgeotmega: {
		randomBattleMoves: ["defog", "heatwave", "hurricane", "roost", "uturn"],
		randomDoubleBattleMoves: ["heatwave", "hurricane", "protect", "tailwind", "uturn"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		randomBattleMoves: ["facade", "flamewheel", "protect", "suckerpunch", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["crunch", "facade", "flamewheel", "protect", "suckerpunch", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		randomBattleMoves: ["doubleedge", "drillpeck", "drillrun", "pursuit", "return", "uturn"],
		randomDoubleBattleMoves: ["doubleedge", "drillpeck", "drillrun", "protect", "quickattack", "return", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		randomBattleMoves: ["aquatail", "coil", "earthquake", "gunkshot", "rest", "suckerpunch"],
		randomDoubleBattleMoves: ["aquatail", "crunch", "earthquake", "gunkshot", "protect", "rest", "rockslide", "suckerpunch"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		randomBattleMoves: ["extremespeed", "grassknot", "hiddenpowerice", "knockoff", "voltswitch", "volttackle"],
		randomDoubleBattleMoves: ["brickbreak", "discharge", "encore", "extremespeed", "fakeout", "grassknot", "hiddenpowerice", "knockoff", "protect", "substitute", "thunderbolt", "voltswitch", "volttackle"],
		tier: "NFE",
	},
	pikachucosplay: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachurockstar: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachubelle: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachupopstar: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachuphd: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pikachulibre: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	raichu: {
		randomBattleMoves: ["encore", "focusblast", "grassknot", "hiddenpowerice", "nastyplot", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["encore", "extremespeed", "fakeout", "focusblast", "grassknot", "hiddenpowerice", "knockoff", "protect", "substitute", "thunderbolt"],
		tier: "PU",
		doublesTier: "DOU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		randomBattleMoves: ["earthquake", "knockoff", "rapidspin", "stealthrock", "swordsdance", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "knockoff", "protect", "rockslide", "stoneedge", "swordsdance", "xscissor"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		randomBattleMoves: ["earthpower", "fireblast", "icebeam", "sludgewave", "stealthrock", "toxicspikes"],
		randomDoubleBattleMoves: ["earthpower", "fireblast", "icebeam", "protect", "sludgebomb"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		randomBattleMoves: ["earthpower", "fireblast", "icebeam", "sludgewave", "substitute", "superpower"],
		randomDoubleBattleMoves: ["earthpower", "fireblast", "focusblast", "icebeam", "protect", "sludgebomb", "thunderbolt"],
		tier: "UU",
		doublesTier: "DUU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "PU",
		doublesTier: "NFE",
	},
	clefable: {
		randomBattleMoves: ["calmmind", "fireblast", "moonblast", "softboiled", "stealthrock", "thunderwave"],
		randomDoubleBattleMoves: ["dazzlinggleam", "fireblast", "followme", "lightscreen", "moonblast", "protect", "reflect", "safeguard", "softboiled", "thunderwave"],
		tier: "OU",
		doublesTier: "DUU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		randomBattleMoves: ["fireblast", "hiddenpowerice", "nastyplot", "solarbeam", "substitute", "willowisp"],
		randomDoubleBattleMoves: ["fireblast", "heatwave", "protect", "solarbeam", "substitute", "willowisp"],
		tier: "PU",
		doublesTier: "DUU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		randomBattleMoves: ["dazzlinggleam", "fireblast", "healbell", "lightscreen", "reflect", "stealthrock"],
		randomDoubleBattleMoves: ["dazzlinggleam", "fireblast", "hypervoice", "icebeam", "knockoff", "lightscreen", "protect", "reflect", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "RU",
		doublesTier: "NFE",
	},
	crobat: {
		randomBattleMoves: ["bravebird", "defog", "roost", "superfang", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "crosspoison", "protect", "superfang", "tailwind", "taunt", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		randomBattleMoves: ["aromatherapy", "gigadrain", "hiddenpowerfire", "sleeppowder", "sludgebomb", "synthesis"],
		randomDoubleBattleMoves: ["dazzlinggleam", "gigadrain", "hiddenpowerfire", "moonblast", "protect", "sleeppowder", "sludgebomb", "stunspore"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	bellossom: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "sleeppowder", "sunnyday", "synthesis"],
		randomDoubleBattleMoves: ["dazzlinggleam", "gigadrain", "hiddenpowerfire", "moonblast", "protect", "sleeppowder", "sludgebomb", "solarbeam", "stunspore", "sunnyday"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		randomBattleMoves: ["knockoff", "leechseed", "seedbomb", "spore", "substitute", "xscissor"],
		randomDoubleBattleMoves: ["knockoff", "leechseed", "protect", "ragepowder", "seedbomb", "spore", "stunspore", "wideguard", "xscissor"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		randomBattleMoves: ["bugbuzz", "quiverdance", "sleeppowder", "sludgebomb", "substitute"],
		randomDoubleBattleMoves: ["bugbuzz", "gigadrain", "protect", "psychic", "quiverdance", "ragepowder", "roost", "sleeppowder", "sludgebomb", "substitute"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		randomBattleMoves: ["earthquake", "reversal", "stealthrock", "stoneedge", "substitute", "suckerpunch"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockslide", "stoneedge", "suckerpunch"],
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		randomBattleMoves: ["fakeout", "knockoff", "return", "taunt", "uturn"],
		randomDoubleBattleMoves: ["fakeout", "feint", "hypnosis", "knockoff", "protect", "return", "taunt", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		randomBattleMoves: ["calmmind", "encore", "hydropump", "icebeam", "psyshock", "scald", "substitute"],
		randomDoubleBattleMoves: ["encore", "focusblast", "hiddenpowergrass", "hydropump", "icebeam", "icywind", "protect", "psychic", "scald", "surf"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		randomBattleMoves: ["closecombat", "earthquake", "encore", "gunkshot", "icepunch", "stoneedge", "uturn"],
		randomDoubleBattleMoves: ["closecombat", "earthquake", "icepunch", "poisonjab", "protect", "punishment", "rockslide", "stoneedge", "taunt", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		randomBattleMoves: ["closecombat", "extremespeed", "flareblitz", "morningsun", "roar", "toxic", "wildcharge", "willowisp"],
		randomDoubleBattleMoves: ["closecombat", "extremespeed", "flareblitz", "protect", "snarl", "wildcharge", "willowisp"],
		tier: "UU",
		doublesTier: "DOU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		randomBattleMoves: ["circlethrow", "focusblast", "hydropump", "icepunch", "raindance", "rest", "scald", "sleeptalk"],
		randomDoubleBattleMoves: ["bellydrum", "brickbreak", "earthquake", "encore", "icepunch", "protect", "rockslide", "waterfall"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	politoed: {
		randomBattleMoves: ["encore", "icebeam", "protect", "rest", "scald", "toxic"],
		randomDoubleBattleMoves: ["encore", "focusblast", "helpinghand", "hiddenpowergrass", "hydropump", "hypnosis", "icebeam", "icywind", "protect", "scald"],
		tier: "(PU)",
		doublesTier: "DOU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "PU",
		doublesTier: "NFE",
	},
	alakazam: {
		randomBattleMoves: ["focusblast", "hiddenpowerfire", "hiddenpowerice", "psychic", "psyshock", "shadowball"],
		randomDoubleBattleMoves: ["dazzlinggleam", "encore", "focusblast", "protect", "psychic", "psyshock", "shadowball", "substitute"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	alakazammega: {
		randomBattleMoves: ["calmmind", "encore", "focusblast", "psyshock", "shadowball", "substitute"],
		randomDoubleBattleMoves: ["dazzlinggleam", "encore", "focusblast", "protect", "psychic", "psyshock", "shadowball", "substitute"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "PUBL",
		doublesTier: "NFE",
	},
	machamp: {
		randomBattleMoves: ["bulletpunch", "dynamicpunch", "heavyslam", "knockoff", "stoneedge", "substitute"],
		randomDoubleBattleMoves: ["bulletpunch", "dynamicpunch", "icepunch", "knockoff", "protect", "rockslide", "stoneedge", "wideguard"],
		tier: "UU",
		doublesTier: "DUU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		randomBattleMoves: ["knockoff", "powerwhip", "sleeppowder", "sludgebomb", "solarbeam", "suckerpunch", "sunnyday", "weatherball"],
		randomDoubleBattleMoves: ["growth", "knockoff", "powerwhip", "protect", "sleeppowder", "sludgebomb", "solarbeam", "suckerpunch", "sunnyday", "weatherball"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		randomBattleMoves: ["acidspray", "knockoff", "rapidspin", "scald", "sludgebomb", "toxicspikes"],
		randomDoubleBattleMoves: ["acidspray", "dazzlinggleam", "gigadrain", "icebeam", "knockoff", "muddywater", "protect", "scald", "sludgebomb"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		randomBattleMoves: ["earthquake", "explosion", "stoneedge", "stealthrock", "suckerpunch", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "firepunch", "hammerarm", "protect", "rockslide", "stoneedge", "suckerpunch"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		randomBattleMoves: ["drillrun", "flareblitz", "morningsun", "wildcharge", "willowisp"],
		randomDoubleBattleMoves: ["drillrun", "flamecharge", "flareblitz", "hypnosis", "megahorn", "protect", "wildcharge", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		randomBattleMoves: ["fireblast", "icebeam", "psyshock", "scald", "slackoff", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["fireblast", "grassknot", "icebeam", "protect", "psychic", "psyshock", "scald", "slackoff", "thunderwave", "trickroom"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	slowbromega: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "psyshock", "scald", "slackoff"],
		randomDoubleBattleMoves: ["fireblast", "grassknot", "icebeam", "protect", "psychic", "psyshock", "scald", "slackoff", "thunderwave", "trickroom"],
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	slowking: {
		randomBattleMoves: ["dragontail", "fireblast", "icebeam", "nastyplot", "psychic", "psyshock", "scald", "slackoff", "thunderwave", "toxic", "trickroom"],
		randomDoubleBattleMoves: ["fireblast", "grassknot", "icebeam", "protect", "psychic", "psyshock", "scald", "slackoff", "thunderwave", "trickroom"],
		tier: "RU",
		doublesTier: "DUU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "RU",
		doublesTier: "NFE",
	},
	magnezone: {
		randomBattleMoves: ["flashcannon", "hiddenpowerfire", "substitute", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["discharge", "electroweb", "flashcannon", "hiddenpowerfire", "hiddenpowerice", "protect", "substitute", "thunderbolt", "voltswitch"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	farfetchd: {
		randomBattleMoves: ["bravebird", "knockoff", "leafblade", "return", "swordsdance"],
		randomDoubleBattleMoves: ["bravebird", "leafblade", "nightslash", "protect", "return", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		randomBattleMoves: ["bravebird", "doubleedge", "knockoff", "quickattack", "return", "roost"],
		randomDoubleBattleMoves: ["bravebird", "doubleedge", "protect", "quickattack", "return"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		randomBattleMoves: ["encore", "icebeam", "protect", "surf", "toxic"],
		randomDoubleBattleMoves: ["encore", "fakeout", "icebeam", "perishsong", "protect", "surf", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		randomBattleMoves: ["curse", "firepunch", "gunkshot", "icepunch", "memento", "poisonjab", "shadowsneak"],
		randomDoubleBattleMoves: ["brickbreak", "firepunch", "gunkshot", "icepunch", "poisonjab", "protect", "shadowsneak"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		randomBattleMoves: ["hydropump", "iceshard", "iciclespear", "rapidspin", "rockblast", "shellsmash", "spikes"],
		randomDoubleBattleMoves: ["hydropump", "iciclespear", "protect", "razorshell", "rockblast", "shellsmash"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NU",
		doublesTier: "NFE",
	},
	gengar: {
		randomBattleMoves: ["disable", "focusblast", "shadowball", "sludgewave", "substitute", "trick", "willowisp"],
		randomDoubleBattleMoves: ["dazzlinggleam", "disable", "focusblast", "hypnosis", "protect", "shadowball", "sludgebomb", "substitute", "taunt", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	gengarmega: {
		randomBattleMoves: ["destinybond", "disable", "focusblast", "perishsong", "protect", "shadowball", "sludgewave", "taunt"],
		randomDoubleBattleMoves: ["dazzlinggleam", "disable", "focusblast", "hypnosis", "protect", "shadowball", "sludgebomb", "substitute", "taunt", "willowisp"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		randomBattleMoves: ["earthquake", "ironhead", "roar", "rockslide", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "explosion", "ironhead", "protect", "rockslide", "stealthrock"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	steelixmega: {
		randomBattleMoves: ["dragontail", "earthquake", "heavyslam", "roar", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "explosion", "heavyslam", "protect", "rockslide", "stealthrock"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		randomBattleMoves: ["foulplay", "protect", "psychic", "seismictoss", "thunderwave", "toxic", "wish"],
		randomDoubleBattleMoves: ["dazzlinggleam", "foulplay", "hypnosis", "protect", "psychic", "seismictoss", "thunderwave", "trickroom", "wish"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		randomBattleMoves: ["agility", "crabhammer", "knockoff", "rockslide", "superpower", "swordsdance", "xscissor"],
		randomDoubleBattleMoves: ["crabhammer", "knockoff", "protect", "rockslide", "substitute", "superpower", "wideguard", "xscissor"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		randomBattleMoves: ["foulplay", "hiddenpowergrass", "hiddenpowerice", "signalbeam", "taunt", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["discharge", "foulplay", "hiddenpowerice", "protect", "taunt", "thunderwave", "voltswitch"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "leechseed", "psychic", "sleeppowder", "substitute"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerfire", "leechseed", "protect", "psychic", "psyshock", "sleeppowder", "substitute", "trickroom"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		randomBattleMoves: ["bonemerang", "doubleedge", "earthquake", "knockoff", "stealthrock", "stoneedge", "substitute"],
		randomDoubleBattleMoves: ["bonemerang", "doubleedge", "earthquake", "firepunch", "protect", "rockslide", "substitute", "swordsdance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		randomBattleMoves: ["fakeout", "highjumpkick", "knockoff", "machpunch", "poisonjab", "rapidspin", "stoneedge"],
		randomDoubleBattleMoves: ["blazekick", "earthquake", "fakeout", "highjumpkick", "knockoff", "machpunch", "protect", "rockslide", "wideguard"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	hitmonchan: {
		randomBattleMoves: ["bulkup", "drainpunch", "firepunch", "icepunch", "machpunch", "rapidspin"],
		randomDoubleBattleMoves: ["drainpunch", "earthquake", "fakeout", "firepunch", "icepunch", "machpunch", "protect", "rockslide", "thunderpunch"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	hitmontop: {
		randomBattleMoves: ["closecombat", "rapidspin", "stoneedge", "suckerpunch", "toxic"],
		randomDoubleBattleMoves: ["closecombat", "fakeout", "feint", "helpinghand", "machpunch", "suckerpunch", "wideguard"],
		tier: "RU",
		doublesTier: "DOU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		randomBattleMoves: ["bodyslam", "dragontail", "earthquake", "explosion", "healbell", "knockoff", "powerwhip", "protect", "swordsdance", "wish"],
		randomDoubleBattleMoves: ["bodyslam", "dragontail", "earthquake", "explosion", "healbell", "knockoff", "powerwhip", "protect", "rockslide", "toxic", "wish"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		randomBattleMoves: ["fireblast", "painsplit", "sludgebomb", "toxicspikes", "willowisp"],
		randomDoubleBattleMoves: ["explosion", "fireblast", "painsplit", "protect", "sludgebomb", "thunderbolt", "toxic", "willowisp"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		randomBattleMoves: ["earthquake", "megahorn", "stealthrock", "stoneedge", "toxic"],
		tier: "NU",
		doublesTier: "NFE",
	},
	rhyperior: {
		randomBattleMoves: ["dragontail", "earthquake", "icepunch", "megahorn", "rockpolish", "stoneedge"],
		randomDoubleBattleMoves: ["earthquake", "hammerarm", "megahorn", "protect", "rockslide", "stealthrock", "stoneedge"],
		tier: "RU",
		doublesTier: "DUU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		randomBattleMoves: ["healbell", "seismictoss", "softboiled", "stealthrock", "thunderwave", "toxic", "wish"],
		randomDoubleBattleMoves: ["aromatherapy", "helpinghand", "lightscreen", "protect", "seismictoss", "softboiled", "thunderwave", "toxic", "wish"],
		tier: "OU",
		doublesTier: "NFE",
	},
	blissey: {
		randomBattleMoves: ["flamethrower", "healbell", "protect", "seismictoss", "softboiled", "stealthrock", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["aromatherapy", "flamethrower", "helpinghand", "icebeam", "protect", "seismictoss", "softboiled", "thunderwave", "toxic", "wish"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	tangela: {
		tier: "PU",
		doublesTier: "NFE",
	},
	tangrowth: {
		randomBattleMoves: ["earthquake", "gigadrain", "hiddenpowerfire", "knockoff", "leafstorm", "rockslide", "sleeppowder", "synthesis"],
		randomDoubleBattleMoves: ["earthquake", "focusblast", "gigadrain", "hiddenpowerice", "knockoff", "leechseed", "powerwhip", "protect", "ragepowder", "sleeppowder"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	kangaskhan: {
		randomBattleMoves: ["crunch", "drainpunch", "earthquake", "fakeout", "return", "suckerpunch"],
		randomDoubleBattleMoves: ["crunch", "doubleedge", "drainpunch", "earthquake", "fakeout", "protect", "return", "suckerpunch"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	kangaskhanmega: {
		randomBattleMoves: ["crunch", "earthquake", "fakeout", "poweruppunch", "return", "seismictoss", "suckerpunch"],
		randomDoubleBattleMoves: ["crunch", "doubleedge", "drainpunch", "earthquake", "fakeout", "poweruppunch", "protect", "return", "suckerpunch"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		randomBattleMoves: ["dracometeor", "dragondance", "hydropump", "icebeam", "outrage", "raindance", "waterfall"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "focusenergy", "hydropump", "icebeam", "muddywater", "protect"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		randomBattleMoves: ["drillrun", "icebeam", "knockoff", "megahorn", "raindance", "waterfall"],
		randomDoubleBattleMoves: ["drillrun", "icebeam", "icywind", "knockoff", "megahorn", "protect", "surf", "waterfall"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		randomBattleMoves: ["hydropump", "icebeam", "psyshock", "rapidspin", "recover", "scald", "thunderbolt"],
		randomDoubleBattleMoves: ["hydropump", "icebeam", "protect", "psychic", "psyshock", "recover", "scald", "surf", "thunderbolt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		randomBattleMoves: ["dazzlinggleam", "encore", "focusblast", "healingwish", "nastyplot", "psyshock", "shadowball"],
		randomDoubleBattleMoves: ["dazzlinggleam", "encore", "fakeout", "hiddenpowerfighting", "icywind", "protect", "teeterdance", "thunderbolt", "thunderwave", "wideguard"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	scyther: {
		randomBattleMoves: ["aerialace", "brickbreak", "bugbite", "knockoff", "quickattack", "roost", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["aerialace", "brickbreak", "bugbite", "feint", "knockoff", "protect", "quickattack", "swordsdance", "uturn"],
		tier: "NU",
		doublesTier: "NFE",
	},
	scizor: {
		randomBattleMoves: ["bugbite", "bulletpunch", "defog", "knockoff", "pursuit", "roost", "superpower", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["bugbite", "bulletpunch", "feint", "knockoff", "protect", "roost", "superpower", "swordsdance", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
	},
	scizormega: {
		randomBattleMoves: ["bugbite", "bulletpunch", "defog", "knockoff", "roost", "superpower", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["bugbite", "bulletpunch", "feint", "knockoff", "protect", "roost", "superpower", "swordsdance", "uturn"],
		tier: "OU",
		doublesTier: "(DOU)",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		randomBattleMoves: ["focusblast", "icebeam", "lovelykiss", "nastyplot", "psychic", "psyshock", "substitute", "trick"],
		randomDoubleBattleMoves: ["hiddenpowerfighting", "icebeam", "lovelykiss", "protect", "psychic", "psyshock", "shadowball", "substitute"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		randomBattleMoves: ["crosschop", "earthquake", "flamethrower", "icepunch", "voltswitch", "wildcharge"],
		randomDoubleBattleMoves: ["crosschop", "earthquake", "flamethrower", "followme", "icepunch", "protect", "substitute", "wildcharge"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		randomBattleMoves: ["earthquake", "fireblast", "focusblast", "hiddenpowergrass", "hiddenpowerice", "substitute", "thunderbolt"],
		randomDoubleBattleMoves: ["fireblast", "focusblast", "followme", "heatwave", "hiddenpowergrass", "hiddenpowerice", "protect", "taunt", "thunderbolt", "willowisp"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pinsir: {
		randomBattleMoves: ["closecombat", "earthquake", "knockoff", "stealthrock", "stoneedge", "xscissor"],
		randomDoubleBattleMoves: ["closecombat", "earthquake", "protect", "rockslide", "substitute", "swordsdance", "xscissor"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pinsirmega: {
		randomBattleMoves: ["closecombat", "earthquake", "quickattack", "return", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "earthquake", "feint", "protect", "quickattack", "return", "rockslide", "substitute", "swordsdance"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	tauros: {
		randomBattleMoves: ["bodyslam", "doubleedge", "earthquake", "rockslide", "zenheadbutt"],
		randomDoubleBattleMoves: ["doubleedge", "earthquake", "protect", "return", "rockslide", "stoneedge", "zenheadbutt"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		randomBattleMoves: ["bounce", "dragondance", "earthquake", "stoneedge", "substitute", "waterfall"],
		randomDoubleBattleMoves: ["bounce", "dragondance", "earthquake", "icefang", "protect", "stoneedge", "substitute", "taunt", "thunderwave", "waterfall"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	gyaradosmega: {
		randomBattleMoves: ["crunch", "dragondance", "earthquake", "icefang", "substitute", "waterfall"],
		randomDoubleBattleMoves: ["bounce", "dragondance", "earthquake", "icefang", "protect", "stoneedge", "substitute", "taunt", "thunderwave", "waterfall"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	lapras: {
		randomBattleMoves: ["freezedry", "healbell", "hydropump", "icebeam", "thunderbolt", "toxic"],
		randomDoubleBattleMoves: ["healbell", "hydropump", "icebeam", "iceshard", "icywind", "protect", "substitute", "surf", "thunderbolt"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	ditto: {
		randomBattleMoves: ["transform"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		randomBattleMoves: ["healbell", "icebeam", "protect", "scald", "toxic", "wish"],
		randomDoubleBattleMoves: ["helpinghand", "hydropump", "icebeam", "muddywater", "protect", "scald", "toxic", "wish"],
		tier: "UU",
		doublesTier: "DUU",
	},
	jolteon: {
		randomBattleMoves: ["hiddenpowerice", "shadowball", "signalbeam", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["helpinghand", "hiddenpowergrass", "hiddenpowerice", "protect", "signalbeam", "substitute", "thunderbolt", "voltswitch"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	flareon: {
		randomBattleMoves: ["facade", "flamecharge", "flareblitz", "quickattack", "superpower"],
		randomDoubleBattleMoves: ["facade", "flamecharge", "flareblitz", "helpinghand", "protect", "superpower", "wish"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	espeon: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "morningsun", "psychic", "psyshock", "shadowball", "substitute"],
		randomDoubleBattleMoves: ["dazzlinggleam", "helpinghand", "hiddenpowerfighting", "protect", "psychic", "psyshock", "shadowball", "substitute", "wish"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	umbreon: {
		randomBattleMoves: ["foulplay", "healbell", "protect", "toxic", "wish"],
		randomDoubleBattleMoves: ["foulplay", "healbell", "helpinghand", "moonlight", "protect", "snarl", "wish"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	leafeon: {
		randomBattleMoves: ["healbell", "knockoff", "leafblade", "swordsdance", "synthesis", "xscissor"],
		randomDoubleBattleMoves: ["helpinghand", "knockoff", "leafblade", "protect", "substitute", "swordsdance", "xscissor"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	glaceon: {
		randomBattleMoves: ["healbell", "hiddenpowerground", "icebeam", "protect", "shadowball", "toxic", "wish"],
		randomDoubleBattleMoves: ["healbell", "helpinghand", "hiddenpowerground", "icebeam", "protect", "shadowball", "wish"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		randomBattleMoves: ["discharge", "icebeam", "recover", "toxic", "triattack"],
		randomDoubleBattleMoves: ["discharge", "icebeam", "protect", "recover", "shadowball", "triattack"],
		tier: "UU",
		doublesTier: "DUU",
	},
	porygonz: {
		randomBattleMoves: ["agility", "darkpulse", "icebeam", "nastyplot", "thunderbolt", "triattack", "trick"],
		randomDoubleBattleMoves: ["agility", "darkpulse", "hiddenpowerfighting", "nastyplot", "protect", "triattack", "trick"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		randomBattleMoves: ["earthpower", "hydropump", "icebeam", "shellsmash", "spikes", "stealthrock"],
		randomDoubleBattleMoves: ["earthpower", "hiddenpowerelectric", "hydropump", "icebeam", "muddywater", "protect", "shellsmash"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		randomBattleMoves: ["aquajet", "knockoff", "rapidspin", "stoneedge", "swordsdance", "waterfall"],
		randomDoubleBattleMoves: ["aquajet", "knockoff", "protect", "rockslide", "stoneedge", "superpower", "swordsdance", "waterfall"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	aerodactyl: {
		randomBattleMoves: ["defog", "doubleedge", "earthquake", "pursuit", "roost", "stealthrock", "stoneedge", "taunt"],
		randomDoubleBattleMoves: ["aquatail", "earthquake", "icefang", "protect", "rockslide", "skydrop", "stoneedge", "tailwind", "taunt", "wideguard"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	aerodactylmega: {
		randomBattleMoves: ["aerialace", "aquatail", "earthquake", "firefang", "honeclaws", "roost", "stoneedge"],
		randomDoubleBattleMoves: ["aerialace", "earthquake", "icefang", "ironhead", "protect", "rockslide", "skydrop", "stoneedge", "tailwind", "taunt", "wideguard"],
		tier: "UU",
		doublesTier: "DUU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		randomBattleMoves: ["bodyslam", "crunch", "curse", "earthquake", "firepunch", "pursuit", "rest", "return", "sleeptalk", "whirlwind"],
		randomDoubleBattleMoves: ["bodyslam", "crunch", "curse", "earthquake", "firepunch", "icepunch", "protect", "return", "selfdestruct"],
		tier: "UU",
		doublesTier: "DUU",
	},
	articuno: {
		randomBattleMoves: ["freezedry", "hurricane", "icebeam", "roost", "substitute", "toxic"],
		randomDoubleBattleMoves: ["freezedry", "hurricane", "protect", "roost", "substitute", "tailwind"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	zapdos: {
		randomBattleMoves: ["defog", "heatwave", "hiddenpowerice", "roost", "thunderbolt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["discharge", "heatwave", "hiddenpowergrass", "hiddenpowerice", "protect", "tailwind", "thunderbolt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	moltres: {
		randomBattleMoves: ["fireblast", "hiddenpowergrass", "hurricane", "roost", "substitute", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["airslash", "fireblast", "heatwave", "hiddenpowergrass", "hurricane", "protect", "roost", "substitute", "tailwind", "uturn", "willowisp"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		randomBattleMoves: ["dragondance", "earthquake", "extremespeed", "firepunch", "outrage", "roost"],
		randomDoubleBattleMoves: ["dracometeor", "dragonclaw", "dragondance", "earthquake", "extremespeed", "firepunch", "protect", "roost", "skydrop", "substitute", "superpower"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	mewtwo: {
		randomBattleMoves: ["aurasphere", "calmmind", "fireblast", "icebeam", "psystrike", "recover"],
		randomDoubleBattleMoves: ["aurasphere", "calmmind", "fireblast", "icebeam", "protect", "psystrike", "recover", "substitute", "taunt", "thunderbolt", "willowisp"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegax: {
		randomBattleMoves: ["bulkup", "drainpunch", "icebeam", "stoneedge", "taunt", "zenheadbutt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegay: {
		randomBattleMoves: ["aurasphere", "calmmind", "fireblast", "icebeam", "psystrike", "recover", "shadowball", "taunt", "willowisp"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	mew: {
		randomBattleMoves: ["aurasphere", "defog", "earthpower", "icebeam", "knockoff", "nastyplot", "psyshock", "roost", "stealthrock", "taunt", "willowisp"],
		randomDoubleBattleMoves: ["aurasphere", "fakeout", "fireblast", "helpinghand", "icebeam", "nastyplot", "protect", "psyshock", "roost", "tailwind", "taunt", "thunderbolt", "transform", "willowisp"],
		tier: "OU",
		doublesTier: "DUU",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		randomBattleMoves: ["aromatherapy", "dragontail", "gigadrain", "leechseed", "lightscreen", "reflect", "synthesis", "toxic"],
		randomDoubleBattleMoves: ["aromatherapy", "dragontail", "gigadrain", "healpulse", "leechseed", "lightscreen", "petalblizzard", "protect", "reflect", "synthesis", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		randomBattleMoves: ["eruption", "extrasensory", "fireblast", "focusblast", "hiddenpowergrass"],
		randomDoubleBattleMoves: ["eruption", "extrasensory", "fireblast", "focusblast", "heatwave", "hiddenpowergrass", "protect"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		randomBattleMoves: ["aquajet", "crunch", "dragondance", "earthquake", "icepunch", "swordsdance", "waterfall"],
		randomDoubleBattleMoves: ["aquajet", "crunch", "dragondance", "earthquake", "icepunch", "protect", "swordsdance", "waterfall"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		randomBattleMoves: ["aquatail", "doubleedge", "firepunch", "knockoff", "trick", "uturn"],
		randomDoubleBattleMoves: ["doubleedge", "firepunch", "followme", "helpinghand", "icepunch", "knockoff", "protect", "suckerpunch", "superfang", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		randomBattleMoves: ["airslash", "defog", "nightshade", "roost", "toxic", "whirlwind"],
		randomDoubleBattleMoves: ["airslash", "heatwave", "hypervoice", "hypnosis", "protect", "roost", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		randomBattleMoves: ["knockoff", "lightscreen", "reflect", "roost", "toxic", "uturn"],
		randomDoubleBattleMoves: ["bugbuzz", "encore", "knockoff", "lightscreen", "protect", "reflect", "tailwind", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		randomBattleMoves: ["megahorn", "poisonjab", "stickyweb", "suckerpunch", "toxicspikes"],
		randomDoubleBattleMoves: ["megahorn", "poisonjab", "protect", "ragepowder", "stickyweb", "stringshot"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		randomBattleMoves: ["healbell", "hydropump", "icebeam", "scald", "thunderbolt", "thunderwave", "toxic", "voltswitch"],
		randomDoubleBattleMoves: ["discharge", "hiddenpowergrass", "hydropump", "icebeam", "protect", "scald", "surf", "thunderbolt", "thunderwave"],
		tier: "NU",
		doublesTier: "DUU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "RU",
		doublesTier: "DUU",
	},
	togekiss: {
		randomBattleMoves: ["airslash", "aurasphere", "defog", "healbell", "nastyplot", "roost", "thunderwave"],
		randomDoubleBattleMoves: ["airslash", "dazzlinggleam", "followme", "nastyplot", "protect", "roost", "tailwind", "thunderwave"],
		tier: "UUBL",
		doublesTier: "DOU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		randomBattleMoves: ["calmmind", "heatwave", "psychic", "reflect", "roost", "thunderwave", "toxic", "uturn"],
		randomDoubleBattleMoves: ["grassknot", "heatwave", "lightscreen", "protect", "psychic", "reflect", "roost", "tailwind", "thunderwave", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		randomBattleMoves: ["focusblast", "healbell", "hiddenpowerice", "lightscreen", "reflect", "thunderbolt", "toxic", "voltswitch"],
		randomDoubleBattleMoves: ["discharge", "dragonpulse", "focusblast", "hiddenpowergrass", "hiddenpowerice", "protect", "thunderbolt"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	ampharosmega: {
		randomBattleMoves: ["agility", "dragonpulse", "focusblast", "healbell", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["discharge", "dragonpulse", "focusblast", "hiddenpowergrass", "hiddenpowerice", "protect", "thunderbolt"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		randomBattleMoves: ["aquajet", "bellydrum", "knockoff", "playrough", "superpower", "waterfall"],
		randomDoubleBattleMoves: ["aquajet", "bellydrum", "knockoff", "playrough", "protect", "superpower", "waterfall"],
		tier: "OU",
		doublesTier: "DOU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		randomBattleMoves: ["earthquake", "stealthrock", "stoneedge", "suckerpunch", "toxic", "woodhammer"],
		randomDoubleBattleMoves: ["earthquake", "explosion", "helpinghand", "protect", "rockslide", "stealthrock", "stoneedge", "suckerpunch", "woodhammer"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		randomBattleMoves: ["acrobatics", "encore", "leechseed", "seedbomb", "sleeppowder", "substitute", "swordsdance", "toxic", "uturn"],
		randomDoubleBattleMoves: ["encore", "gigadrain", "helpinghand", "leechseed", "protect", "ragepowder", "sleeppowder", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	aipom: {
		tier: "LC",
	},
	ambipom: {
		randomBattleMoves: ["fakeout", "knockoff", "lowkick", "return", "seedbomb", "switcheroo", "uturn"],
		randomDoubleBattleMoves: ["doublehit", "fakeout", "icepunch", "knockoff", "lowkick", "protect", "return", "uturn"],
		tier: "RU",
		doublesTier: "DUU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		randomBattleMoves: ["earthpower", "gigadrain", "hiddenpowerfire", "solarbeam", "sunnyday"],
		randomDoubleBattleMoves: ["earthpower", "encore", "gigadrain", "hiddenpowerfire", "hiddenpowerice", "protect", "solarbeam", "sunnyday"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	yanma: {
		tier: "NFE",
	},
	yanmega: {
		randomBattleMoves: ["airslash", "bugbuzz", "gigadrain", "protect", "uturn"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		randomBattleMoves: ["earthquake", "encore", "icebeam", "recover", "scald", "toxic"],
		randomDoubleBattleMoves: ["curse", "earthquake", "icepunch", "icywind", "protect", "rockslide", "scald", "waterfall", "yawn"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	murkrow: {
		tier: "NFE",
	},
	honchkrow: {
		randomBattleMoves: ["bravebird", "heatwave", "pursuit", "roost", "suckerpunch", "superpower"],
		randomDoubleBattleMoves: ["bravebird", "heatwave", "protect", "roost", "substitute", "suckerpunch", "superpower"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	misdreavus: {
		tier: "PU",
		doublesTier: "NFE",
	},
	mismagius: {
		randomBattleMoves: ["dazzlinggleam", "destinybond", "nastyplot", "painsplit", "shadowball", "substitute", "taunt", "thunderbolt", "willowisp"],
		randomDoubleBattleMoves: ["dazzlinggleam", "nastyplot", "protect", "shadowball", "substitute", "taunt", "thunderbolt", "willowisp"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	unown: {
		randomBattleMoves: ["hiddenpowerpsychic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		randomBattleMoves: ["counter", "destinybond", "encore", "mirrorcoat", "safeguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	girafarig: {
		randomBattleMoves: ["hypervoice", "nastyplot", "psychic", "psyshock", "substitute", "thunderbolt"],
		randomDoubleBattleMoves: ["agility", "hypervoice", "nastyplot", "protect", "psychic", "psyshock", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		randomBattleMoves: ["gyroball", "rapidspin", "spikes", "stealthrock", "toxic", "voltswitch"],
		randomDoubleBattleMoves: ["drillrun", "gyroball", "protect", "rockslide", "stealthrock", "toxic", "voltswitch"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	dunsparce: {
		randomBattleMoves: ["bite", "bodyslam", "coil", "glare", "headbutt", "rockslide", "roost"],
		randomDoubleBattleMoves: ["bite", "bodyslam", "coil", "glare", "headbutt", "protect", "rockslide"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gligar: {
		randomBattleMoves: ["defog", "earthquake", "knockoff", "roost", "stealthrock", "toxic", "uturn"],
		tier: "UU",
		doublesTier: "NFE",
	},
	gliscor: {
		randomBattleMoves: ["earthquake", "knockoff", "protect", "roost", "stealthrock", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["earthquake", "knockoff", "protect", "stoneedge", "substitute", "tailwind", "taunt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		randomBattleMoves: ["crunch", "earthquake", "healbell", "playrough", "thunderwave"],
		randomDoubleBattleMoves: ["crunch", "earthquake", "playrough", "protect", "rockslide", "snarl", "thunderwave"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	qwilfish: {
		randomBattleMoves: ["destinybond", "painsplit", "spikes", "taunt", "thunderwave", "toxicspikes", "waterfall"],
		randomDoubleBattleMoves: ["destinybond", "poisonjab", "protect", "swordsdance", "taunt", "thunderwave", "waterfall"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	shuckle: {
		randomBattleMoves: ["encore", "knockoff", "stealthrock", "stickyweb", "toxic"],
		randomDoubleBattleMoves: ["encore", "guardsplit", "helpinghand", "knockoff", "powersplit", "stealthrock", "stickyweb", "toxic"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	heracross: {
		randomBattleMoves: ["closecombat", "earthquake", "knockoff", "megahorn", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "earthquake", "knockoff", "megahorn", "protect", "stoneedge", "swordsdance"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	heracrossmega: {
		randomBattleMoves: ["bulletseed", "closecombat", "pinmissile", "rockblast", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["bulletseed", "closecombat", "earthquake", "knockoff", "pinmissile", "protect", "rockblast", "swordsdance"],
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	sneasel: {
		tier: "RU",
		doublesTier: "NFE",
	},
	weavile: {
		randomBattleMoves: ["iceshard", "iciclecrash", "knockoff", "lowkick", "pursuit", "swordsdance"],
		randomDoubleBattleMoves: ["fakeout", "feint", "iceshard", "iciclecrash", "knockoff", "lowkick", "protect", "swordsdance", "taunt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		randomBattleMoves: ["closecombat", "crunch", "facade", "protect", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "crunch", "earthquake", "facade", "protect", "swordsdance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		randomBattleMoves: ["ancientpower", "earthpower", "fireblast", "hiddenpowergrass", "lavaplume", "recover", "shellsmash", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["ancientpower", "earthpower", "fireblast", "heatwave", "hiddenpowergrass", "protect", "shellsmash", "stealthrock", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NU",
		doublesTier: "NFE",
	},
	mamoswine: {
		randomBattleMoves: ["earthquake", "iceshard", "iciclecrash", "knockoff", "stealthrock", "superpower"],
		randomDoubleBattleMoves: ["earthquake", "iceshard", "iciclecrash", "knockoff", "protect", "rockslide", "superpower"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	corsola: {
		randomBattleMoves: ["powergem", "recover", "scald", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthpower", "icebeam", "icywind", "powergem", "protect", "scald", "stealthrock"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		randomBattleMoves: ["energyball", "fireblast", "gunkshot", "hydropump", "icebeam", "rockblast", "scald"],
		randomDoubleBattleMoves: ["chargebeam", "energyball", "fireblast", "hydropump", "icebeam", "protect", "surf"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	delibird: {
		randomBattleMoves: ["destinybond", "freezedry", "icywind", "rapidspin", "spikes"],
		randomDoubleBattleMoves: ["aerialace", "brickbreak", "fakeout", "icepunch", "iceshard", "protect"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		randomBattleMoves: ["airslash", "defog", "rest", "scald", "sleeptalk", "toxic"],
		randomDoubleBattleMoves: ["airslash", "helpinghand", "hydropump", "icebeam", "protect", "raindance", "scald", "surf", "tailwind", "wideguard"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	skarmory: {
		randomBattleMoves: ["bravebird", "defog", "roost", "spikes", "stealthrock", "whirlwind"],
		randomDoubleBattleMoves: ["bravebird", "feint", "ironhead", "protect", "skydrop", "tailwind", "taunt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		randomBattleMoves: ["darkpulse", "fireblast", "hiddenpowergrass", "nastyplot", "suckerpunch"],
		randomDoubleBattleMoves: ["darkpulse", "heatwave", "hiddenpowerfighting", "nastyplot", "protect", "suckerpunch"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	houndoommega: {
		randomBattleMoves: ["darkpulse", "fireblast", "hiddenpowergrass", "nastyplot", "taunt"],
		randomDoubleBattleMoves: ["darkpulse", "heatwave", "hiddenpowergrass", "nastyplot", "protect", "taunt"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		randomBattleMoves: ["earthquake", "iceshard", "knockoff", "rapidspin", "stealthrock", "stoneedge"],
		randomDoubleBattleMoves: ["earthquake", "iceshard", "knockoff", "protect", "rockslide", "stealthrock"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	stantler: {
		randomBattleMoves: ["doubleedge", "earthquake", "jumpkick", "megahorn", "suckerpunch"],
		randomDoubleBattleMoves: ["earthquake", "jumpkick", "megahorn", "protect", "return", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	smeargle: {
		randomBattleMoves: ["destinybond", "spore", "stealthrock", "stickyweb", "whirlwind"],
		randomDoubleBattleMoves: ["fakeout", "followme", "helpinghand", "kingsshield", "spore", "tailwind", "transform", "wideguard"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	miltank: {
		randomBattleMoves: ["bodyslam", "curse", "earthquake", "healbell", "milkdrink", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["bodyslam", "curse", "earthquake", "healbell", "helpinghand", "protect", "thunderwave"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	raikou: {
		randomBattleMoves: ["aurasphere", "calmmind", "extrasensory", "hiddenpowerice", "substitute", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["calmmind", "extrasensory", "hiddenpowerice", "protect", "snarl", "substitute", "thunderbolt"],
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	entei: {
		randomBattleMoves: ["bulldoze", "extremespeed", "flareblitz", "sacredfire", "stoneedge"],
		randomDoubleBattleMoves: ["bulldoze", "extremespeed", "flareblitz", "ironhead", "protect", "sacredfire", "stoneedge"],
		tier: "UU",
		doublesTier: "DUU",
	},
	suicune: {
		randomBattleMoves: ["calmmind", "hiddenpowergrass", "hydropump", "icebeam", "rest", "scald", "sleeptalk"],
		randomDoubleBattleMoves: ["calmmind", "hiddenpowergrass", "hydropump", "icebeam", "protect", "scald", "snarl", "tailwind"],
		tier: "UU",
		doublesTier: "DOU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		randomBattleMoves: ["crunch", "earthquake", "fireblast", "icebeam", "pursuit", "stealthrock", "stoneedge"],
		randomDoubleBattleMoves: ["crunch", "earthquake", "firepunch", "icepunch", "protect", "rockslide", "stealthrock", "stoneedge"],
		tier: "OU",
		doublesTier: "DOU",
	},
	tyranitarmega: {
		randomBattleMoves: ["crunch", "dragondance", "earthquake", "icepunch", "stoneedge"],
		randomDoubleBattleMoves: ["crunch", "dragondance", "earthquake", "icepunch", "protect", "rockslide", "stoneedge"],
		tier: "(OU)",
		doublesTier: "(DOU)",
	},
	lugia: {
		randomBattleMoves: ["aeroblast", "earthquake", "roost", "substitute", "toxic", "whirlwind"],
		randomDoubleBattleMoves: ["aeroblast", "calmmind", "icebeam", "protect", "psychic", "roost", "skydrop", "substitute", "tailwind"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	hooh: {
		randomBattleMoves: ["bravebird", "earthquake", "roost", "sacredfire", "substitute", "toxic"],
		randomDoubleBattleMoves: ["bravebird", "earthquake", "protect", "roost", "sacredfire", "skydrop", "substitute", "tailwind", "toxic"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	celebi: {
		randomBattleMoves: ["earthpower", "gigadrain", "hiddenpowerfire", "leafstorm", "nastyplot", "psychic", "recover", "thunderwave", "uturn"],
		randomDoubleBattleMoves: ["earthpower", "gigadrain", "hiddenpowerfire", "leafstorm", "leechseed", "nastyplot", "protect", "psychic", "recover", "thunderwave", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		randomBattleMoves: ["focusblast", "gigadrain", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "leechseed", "substitute"],
		randomDoubleBattleMoves: ["focusblast", "gigadrain", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "protect", "substitute"],
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	sceptilemega: {
		randomBattleMoves: ["dragonpulse", "earthquake", "focusblast", "gigadrain", "hiddenpowerfire", "leafblade", "outrage", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["dragonpulse", "focusblast", "gigadrain", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "protect", "substitute"],
		tier: "UU",
		doublesTier: "DUU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "PU",
		doublesTier: "NFE",
	},
	blaziken: {
		randomBattleMoves: ["fireblast", "hiddenpowerice", "highjumpkick", "knockoff", "protect"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	blazikenmega: {
		randomBattleMoves: ["flareblitz", "highjumpkick", "knockoff", "protect", "stoneedge", "swordsdance"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		randomBattleMoves: ["earthquake", "icebeam", "protect", "roar", "scald", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "icebeam", "icywind", "muddywater", "protect", "rockslide", "scald", "stealthrock", "waterfall", "wideguard"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	swampertmega: {
		randomBattleMoves: ["earthquake", "icepunch", "raindance", "superpower", "waterfall"],
		randomDoubleBattleMoves: ["earthquake", "icepunch", "protect", "raindance", "superpower", "waterfall"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		randomBattleMoves: ["crunch", "firefang", "irontail", "playrough", "suckerpunch"],
		randomDoubleBattleMoves: ["crunch", "firefang", "playrough", "protect", "suckerpunch", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		randomBattleMoves: ["bellydrum", "extremespeed", "seedbomb", "shadowclaw"],
		randomDoubleBattleMoves: ["bellydrum", "extremespeed", "protect", "seedbomb", "shadowclaw"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		randomBattleMoves: ["bugbuzz", "energyball", "hiddenpowerfighting", "psychic", "quiverdance"],
		randomDoubleBattleMoves: ["aircutter", "bugbuzz", "gigadrain", "hiddenpowerrock", "protect", "quiverdance", "stringshot", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		randomBattleMoves: ["bugbuzz", "defog", "quiverdance", "roost", "sludgebomb", "uturn"],
		randomDoubleBattleMoves: ["bugbuzz", "protect", "quiverdance", "shadowball", "sludgebomb", "stringshot", "strugglebug", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		randomBattleMoves: ["focusblast", "gigadrain", "hydropump", "icebeam", "raindance", "scald"],
		randomDoubleBattleMoves: ["fakeout", "gigadrain", "hydropump", "icebeam", "protect", "raindance", "surf"],
		tier: "NU",
		doublesTier: "DOU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		randomBattleMoves: ["defog", "knockoff", "leafblade", "leafstorm", "lowkick", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["fakeout", "knockoff", "leafblade", "leafstorm", "lowkick", "protect", "suckerpunch", "swordsdance"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		randomBattleMoves: ["bravebird", "facade", "protect", "quickattack", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "facade", "protect", "quickattack", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		randomBattleMoves: ["defog", "hurricane", "knockoff", "roost", "scald", "toxic", "uturn"],
		randomDoubleBattleMoves: ["hurricane", "knockoff", "protect", "scald", "surf", "tailwind", "wideguard"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		randomBattleMoves: ["calmmind", "focusblast", "moonblast", "psychic", "shadowball", "substitute", "thunderbolt", "willowisp"],
		randomDoubleBattleMoves: ["dazzlinggleam", "focusblast", "helpinghand", "moonblast", "protect", "psyshock", "shadowball", "taunt", "thunderbolt", "trickroom", "willowisp"],
		tier: "UU",
		doublesTier: "DUU",
	},
	gardevoirmega: {
		randomBattleMoves: ["calmmind", "focusblast", "hypervoice", "psyshock", "substitute", "taunt", "willowisp"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "hypervoice", "protect", "psyshock", "shadowball", "thunderbolt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	gallade: {
		randomBattleMoves: ["closecombat", "icepunch", "knockoff", "shadowsneak", "swordsdance", "trick", "zenheadbutt"],
		randomDoubleBattleMoves: ["closecombat", "drainpunch", "helpinghand", "icepunch", "knockoff", "protect", "shadowsneak", "stoneedge", "trick", "trickroom", "zenheadbutt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gallademega: {
		randomBattleMoves: ["closecombat", "drainpunch", "knockoff", "substitute", "swordsdance", "zenheadbutt"],
		randomDoubleBattleMoves: ["closecombat", "drainpunch", "icepunch", "knockoff", "protect", "stoneedge", "swordsdance", "zenheadbutt"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		randomBattleMoves: ["airslash", "bugbuzz", "hydropump", "quiverdance", "stickyweb"],
		randomDoubleBattleMoves: ["airslash", "bugbuzz", "hydropump", "protect", "quiverdance", "roost", "strugglebug", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		randomBattleMoves: ["bulletseed", "machpunch", "rocktomb", "spore", "swordsdance"],
		randomDoubleBattleMoves: ["bulletseed", "drainpunch", "helpinghand", "machpunch", "protect", "rocktomb", "spore"],
		tier: "OU",
		doublesTier: "DOU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "PUBL",
		doublesTier: "NFE",
	},
	slaking: {
		randomBattleMoves: ["earthquake", "firepunch", "gigaimpact", "nightslash", "pursuit", "retaliate"],
		randomDoubleBattleMoves: ["doubleedge", "earthquake", "hammerarm", "nightslash", "retaliate", "rockslide"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		randomBattleMoves: ["aerialace", "nightslash", "swordsdance", "uturn", "xscissor"],
		randomDoubleBattleMoves: ["aerialace", "nightslash", "protect", "swordsdance", "xscissor"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shedinja: {
		randomBattleMoves: ["shadowclaw", "shadowsneak", "swordsdance", "willowisp", "xscissor"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		randomBattleMoves: ["boomburst", "fireblast", "focusblast", "icebeam", "surf"],
		randomDoubleBattleMoves: ["boomburst", "fireblast", "focusblast", "hypervoice", "icebeam", "protect", "surf"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		randomBattleMoves: ["bulkup", "bulletpunch", "closecombat", "icepunch", "knockoff", "stoneedge"],
		randomDoubleBattleMoves: ["bulletpunch", "closecombat", "fakeout", "helpinghand", "icepunch", "knockoff", "protect", "stoneedge", "wideguard"],
		tier: "NU",
		doublesTier: "DUU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		randomBattleMoves: ["earthpower", "flashcannon", "stealthrock", "thunderwave", "toxic", "voltswitch"],
		randomDoubleBattleMoves: ["earthpower", "helpinghand", "powergem", "protect", "stealthrock", "thunderwave", "voltswitch", "wideguard"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		randomBattleMoves: ["doubleedge", "fakeout", "healbell", "suckerpunch", "thunderwave", "wildcharge"],
		randomDoubleBattleMoves: ["doubleedge", "fakeout", "helpinghand", "playrough", "protect", "suckerpunch", "thunderwave", "wildcharge"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	sableye: {
		randomBattleMoves: ["foulplay", "knockoff", "recover", "taunt", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["fakeout", "foulplay", "helpinghand", "knockoff", "protect", "recover", "snarl", "taunt", "willowisp"],
		tier: "RUBL",
		doublesTier: "DUU",
	},
	sableyemega: {
		randomBattleMoves: ["calmmind", "darkpulse", "recover", "shadowball", "willowisp"],
		randomDoubleBattleMoves: ["darkpulse", "fakeout", "knockoff", "protect", "shadowball", "willowisp"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	mawile: {
		randomBattleMoves: ["ironhead", "knockoff", "playrough", "stealthrock", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["firefang", "ironhead", "knockoff", "playrough", "protect", "substitute", "suckerpunch", "swordsdance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	mawilemega: {
		randomBattleMoves: ["firefang", "focuspunch", "ironhead", "knockoff", "playrough", "substitute", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["firefang", "ironhead", "knockoff", "playrough", "protect", "substitute", "suckerpunch", "swordsdance"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		randomBattleMoves: ["aquatail", "autotomize", "earthquake", "headsmash", "heavyslam", "stealthrock"],
		randomDoubleBattleMoves: ["aquatail", "earthquake", "headsmash", "heavyslam", "lowkick", "protect", "rockslide", "stealthrock"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	aggronmega: {
		randomBattleMoves: ["earthquake", "heavyslam", "roar", "stoneedge", "stealthrock", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["aquatail", "earthquake", "heavyslam", "lowkick", "protect", "rockslide"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		randomBattleMoves: ["bulletpunch", "drainpunch", "highjumpkick", "icepunch", "zenheadbutt"],
		randomDoubleBattleMoves: ["bulletpunch", "drainpunch", "fakeout", "highjumpkick", "icepunch", "protect", "zenheadbutt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	medichammega: {
		randomBattleMoves: ["fakeout", "highjumpkick", "icepunch", "thunderpunch", "zenheadbutt"],
		randomDoubleBattleMoves: ["bulletpunch", "drainpunch", "fakeout", "highjumpkick", "icepunch", "protect", "zenheadbutt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		randomBattleMoves: ["flamethrower", "hiddenpowergrass", "hiddenpowerice", "overheat", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["flamethrower", "hiddenpowergrass", "hiddenpowerice", "overheat", "protect", "snarl", "thunderbolt", "voltswitch"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	manectricmega: {
		randomBattleMoves: ["hiddenpowergrass", "hiddenpowerice", "overheat", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["flamethrower", "hiddenpowergrass", "hiddenpowerice", "overheat", "protect", "snarl", "thunderbolt", "voltswitch"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	plusle: {
		randomBattleMoves: ["encore", "hiddenpowerice", "nastyplot", "substitute", "thunderbolt"],
		randomDoubleBattleMoves: ["encore", "helpinghand", "hiddenpowerice", "nastyplot", "protect", "substitute", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	minun: {
		randomBattleMoves: ["encore", "hiddenpowerice", "nastyplot", "substitute", "thunderbolt"],
		randomDoubleBattleMoves: ["encore", "helpinghand", "hiddenpowerice", "nastyplot", "protect", "substitute", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	volbeat: {
		randomBattleMoves: ["encore", "roost", "tailwind", "thunderwave", "uturn"],
		randomDoubleBattleMoves: ["encore", "helpinghand", "protect", "stringshot", "strugglebug", "tailwind", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	illumise: {
		randomBattleMoves: ["bugbuzz", "encore", "roost", "thunderwave", "uturn", "wish"],
		randomDoubleBattleMoves: ["bugbuzz", "encore", "helpinghand", "protect", "tailwind", "thunderbolt", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "PU",
		doublesTier: "NFE",
	},
	roserade: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "leafstorm", "sleeppowder", "sludgebomb", "spikes", "synthesis", "toxicspikes"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerfire", "leafstorm", "protect", "sleeppowder", "sludgebomb"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		randomBattleMoves: ["earthquake", "encore", "icebeam", "painsplit", "sludgebomb", "toxic", "yawn"],
		randomDoubleBattleMoves: ["earthquake", "encore", "gunkshot", "icebeam", "protect", "sludgebomb", "yawn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		randomBattleMoves: ["crunch", "earthquake", "icebeam", "protect", "waterfall"],
		randomDoubleBattleMoves: ["crunch", "destinybond", "earthquake", "icebeam", "protect", "waterfall"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	sharpedomega: {
		randomBattleMoves: ["crunch", "destinybond", "icefang", "protect", "waterfall", "zenheadbutt"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		randomBattleMoves: ["hiddenpowerfire", "hiddenpowergrass", "hydropump", "icebeam", "waterspout"],
		randomDoubleBattleMoves: ["hiddenpowerfire", "hiddenpowergrass", "hydropump", "icebeam", "protect", "waterspout"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		randomBattleMoves: ["earthpower", "fireblast", "hiddenpowergrass", "lavaplume", "roar", "rockpolish", "stealthrock", "stoneedge"],
		randomDoubleBattleMoves: ["earthpower", "eruption", "fireblast", "heatwave", "hiddenpowergrass", "protect", "rockpolish"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	cameruptmega: {
		randomBattleMoves: ["ancientpower", "earthpower", "fireblast", "stealthrock", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["earthpower", "eruption", "fireblast", "heatwave", "protect", "rockslide"],
		tier: "RU",
		doublesTier: "DUU",
	},
	torkoal: {
		randomBattleMoves: ["earthpower", "lavaplume", "rapidspin", "stealthrock", "yawn"],
		randomDoubleBattleMoves: ["earthpower", "fireblast", "heatwave", "hiddenpowergrass", "protect", "shellsmash", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		randomBattleMoves: ["focusblast", "healbell", "lightscreen", "psychic", "reflect", "thunderwave", "toxic", "whirlwind"],
		randomDoubleBattleMoves: ["focusblast", "lightscreen", "protect", "psychic", "psyshock", "reflect", "taunt", "thunderwave", "trickroom"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	spinda: {
		randomBattleMoves: ["icepunch", "rest", "return", "sleeptalk", "suckerpunch", "superpower"],
		randomDoubleBattleMoves: ["doubleedge", "fakeout", "protect", "return", "suckerpunch", "superpower", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		randomBattleMoves: ["defog", "earthquake", "fireblast", "outrage", "roost", "stoneedge", "uturn"],
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "feint", "fireblast", "firepunch", "protect", "rockslide", "tailwind", "uturn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		randomBattleMoves: ["darkpulse", "drainpunch", "focusblast", "seedbomb", "spikes", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["drainpunch", "seedbomb", "spikyshield", "substitute", "suckerpunch", "swordsdance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		randomBattleMoves: ["dracometeor", "dragondance", "earthquake", "fireblast", "outrage", "roost", "toxic"],
		randomDoubleBattleMoves: ["dracometeor", "dragonclaw", "dragondance", "earthquake", "fireblast", "protect", "tailwind"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	altariamega: {
		randomBattleMoves: ["dragondance", "earthquake", "fireblast", "healbell", "hypervoice", "return", "roost"],
		randomDoubleBattleMoves: ["doubleedge", "dragonclaw", "dragondance", "earthquake", "fireblast", "protect", "return"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	zangoose: {
		randomBattleMoves: ["closecombat", "facade", "knockoff", "quickattack", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "facade", "knockoff", "protect", "quickattack"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	seviper: {
		randomBattleMoves: ["darkpulse", "earthquake", "flamethrower", "gigadrain", "poisonjab", "sludgewave", "suckerpunch", "switcheroo"],
		randomDoubleBattleMoves: ["aquatail", "earthquake", "flamethrower", "gigadrain", "glare", "poisonjab", "protect", "sludgebomb", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lunatone: {
		randomBattleMoves: ["ancientpower", "calmmind", "earthpower", "icebeam", "moonlight", "psychic", "rockpolish", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["ancientpower", "calmmind", "earthpower", "helpinghand", "icebeam", "moonlight", "protect", "psychic", "rockpolish", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	solrock: {
		randomBattleMoves: ["explosion", "earthquake", "lightscreen", "morningsun", "reflect", "rockslide", "stealthrock", "willowisp"],
		randomDoubleBattleMoves: ["helpinghand", "protect", "rockslide", "stoneedge", "trickroom", "willowisp", "zenheadbutt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		randomBattleMoves: ["dragondance", "earthquake", "stoneedge", "waterfall", "zenheadbutt"],
		randomDoubleBattleMoves: ["dragondance", "earthquake", "protect", "stoneedge", "waterfall", "zenheadbutt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		randomBattleMoves: ["aquajet", "crabhammer", "dragondance", "knockoff", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["aquajet", "crabhammer", "crunch", "dragondance", "knockoff", "protect", "superpower", "swordsdance"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		randomBattleMoves: ["earthquake", "icebeam", "psychic", "rapidspin", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthpower", "earthquake", "icebeam", "protect", "psychic", "trickroom"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		randomBattleMoves: ["curse", "gigadrain", "recover", "rockslide", "seedbomb", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["curse", "earthquake", "protect", "recover", "rockslide", "seedbomb", "swordsdance"],
		tier: "NU",
		doublesTier: "DUU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		randomBattleMoves: ["earthquake", "knockoff", "rapidspin", "stealthrock", "stoneedge", "toxic", "xscissor"],
		randomDoubleBattleMoves: ["knockoff", "protect", "rockslide", "stoneedge", "stringshot", "swordsdance", "xscissor"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		randomBattleMoves: ["dragontail", "icebeam", "recover", "rest", "scald", "sleeptalk", "toxic"],
		randomDoubleBattleMoves: ["dragontail", "hiddenpowergrass", "hydropump", "hypnosis", "icebeam", "protect", "recover", "scald"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	castform: {
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	castformsunny: {
		randomBattleMoves: ["icebeam", "solarbeam", "sunnyday", "weatherball"],
	},
	castformrainy: {
		randomBattleMoves: ["hurricane", "raindance", "thunder", "weatherball"],
	},
	castformsnowy: {
		randomBattleMoves: ["blizzard", "fireblast", "hail", "thunderbolt"],
	},
	kecleon: {
		randomBattleMoves: ["drainpunch", "fakeout", "knockoff", "recover", "shadowsneak", "stealthrock", "suckerpunch"],
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "knockoff", "protect", "recover", "shadowsneak", "suckerpunch", "trickroom"],
		tier: "NU",
		doublesTier: "DUU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		randomBattleMoves: ["destinybond", "knockoff", "shadowclaw", "shadowsneak", "suckerpunch", "taunt", "willowisp"],
		randomDoubleBattleMoves: ["knockoff", "protect", "shadowclaw", "shadowsneak", "suckerpunch", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	banettemega: {
		randomBattleMoves: ["destinybond", "knockoff", "shadowclaw", "suckerpunch", "taunt", "willowisp"],
		randomDoubleBattleMoves: ["destinybond", "knockoff", "protect", "shadowclaw", "suckerpunch", "taunt", "willowisp"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		randomBattleMoves: ["earthquake", "focuspunch", "icepunch", "painsplit", "shadowsneak", "substitute", "willowisp"],
		randomDoubleBattleMoves: ["earthquake", "helpinghand", "icepunch", "painsplit", "protect", "shadowsneak", "trickroom", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	tropius: {
		randomBattleMoves: ["airslash", "gigadrain", "leechseed", "protect", "substitute", "toxic"],
		randomDoubleBattleMoves: ["airslash", "earthquake", "gigadrain", "hiddenpowerfire", "leechseed", "protect", "roost", "sunnyday", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		randomBattleMoves: ["calmmind", "healbell", "healingwish", "psychic", "recover", "shadowball", "taunt", "yawn"],
		randomDoubleBattleMoves: ["dazzlinggleam", "helpinghand", "protect", "psychic", "recover", "shadowball", "taunt", "thunderwave", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	absol: {
		randomBattleMoves: ["knockoff", "playrough", "pursuit", "suckerpunch", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["fireblast", "knockoff", "playrough", "protect", "suckerpunch", "superpower", "swordsdance"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	absolmega: {
		randomBattleMoves: ["icebeam", "knockoff", "playrough", "pursuit", "suckerpunch", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["fireblast", "knockoff", "playrough", "protect", "suckerpunch", "superpower", "swordsdance"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		randomBattleMoves: ["earthquake", "explosion", "icebeam", "iceshard", "spikes", "superfang", "taunt"],
		randomDoubleBattleMoves: ["earthquake", "icebeam", "iceshard", "protect", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	glaliemega: {
		randomBattleMoves: ["earthquake", "explosion", "freezedry", "iceshard", "return", "spikes"],
		randomDoubleBattleMoves: ["crunch", "earthquake", "explosion", "freezedry", "iceshard", "protect", "return"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	froslass: {
		randomBattleMoves: ["destinybond", "icebeam", "shadowball", "spikes", "taunt", "thunderwave"],
		randomDoubleBattleMoves: ["destinybond", "icebeam", "protect", "shadowball", "taunt", "thunderwave"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		randomBattleMoves: ["icebeam", "protect", "roar", "superfang", "surf", "toxic"],
		randomDoubleBattleMoves: ["icebeam", "icywind", "protect", "roar", "superfang", "surf"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	clamperl: {
		tier: "LC",
	},
	huntail: {
		randomBattleMoves: ["icebeam", "shellsmash", "suckerpunch", "waterfall"],
		randomDoubleBattleMoves: ["icefang", "protect", "shellsmash", "suckerpunch", "waterfall"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gorebyss: {
		randomBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "shellsmash"],
		randomDoubleBattleMoves: ["hiddenpowergrass", "icebeam", "protect", "shellsmash", "substitute", "surf"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	relicanth: {
		randomBattleMoves: ["doubleedge", "earthquake", "headsmash", "stealthrock", "toxic", "waterfall"],
		randomDoubleBattleMoves: ["doubleedge", "earthquake", "headsmash", "protect", "rockslide", "waterfall"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	luvdisc: {
		randomBattleMoves: ["icebeam", "protect", "scald", "sweetkiss", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		randomBattleMoves: ["dracometeor", "dragonclaw", "dragondance", "earthquake", "fireblast", "outrage", "roost"],
		randomDoubleBattleMoves: ["dracometeor", "dragonclaw", "dragondance", "earthquake", "fireblast", "hydropump", "protect", "rockslide", "tailwind"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	salamencemega: {
		randomBattleMoves: ["doubleedge", "dracometeor", "dragondance", "earthquake", "fireblast", "return", "roost"],
		randomDoubleBattleMoves: ["doubleedge", "dracometeor", "dragonclaw", "dragondance", "earthquake", "fireblast", "protect", "return"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "PU",
		doublesTier: "NFE",
	},
	metagross: {
		randomBattleMoves: ["agility", "bulletpunch", "earthquake", "explosion", "icepunch", "meteormash", "stealthrock", "thunderpunch", "zenheadbutt"],
		randomDoubleBattleMoves: ["bulletpunch", "earthquake", "explosion", "hammerarm", "icepunch", "meteormash", "protect", "thunderpunch", "zenheadbutt"],
		tier: "UU",
		doublesTier: "DUU",
	},
	metagrossmega: {
		randomBattleMoves: ["agility", "earthquake", "hammerarm", "icepunch", "meteormash", "zenheadbutt"],
		randomDoubleBattleMoves: ["earthquake", "icepunch", "meteormash", "protect", "thunderpunch", "zenheadbutt"],
		tier: "OU",
		doublesTier: "DUU",
	},
	regirock: {
		randomBattleMoves: ["curse", "drainpunch", "earthquake", "rest", "stealthrock", "stoneedge", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["curse", "drainpunch", "protect", "rockslide", "stealthrock", "stoneedge", "thunderwave"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	regice: {
		randomBattleMoves: ["focusblast", "icebeam", "rest", "rockpolish", "sleeptalk", "thunderbolt", "thunderwave"],
		randomDoubleBattleMoves: ["focusblast", "icebeam", "icywind", "protect", "rockpolish", "thunderbolt", "thunderwave"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	registeel: {
		randomBattleMoves: ["curse", "ironhead", "rest", "sleeptalk", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["curse", "ironhead", "protect", "rest", "seismictoss", "stealthrock", "thunderwave"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	latias: {
		randomBattleMoves: ["defog", "dracometeor", "healingwish", "hiddenpowerfire", "psyshock", "roost"],
		randomDoubleBattleMoves: ["dragonpulse", "healpulse", "helpinghand", "lightscreen", "protect", "psychic", "reflect", "tailwind"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	latiasmega: {
		randomBattleMoves: ["calmmind", "dracometeor", "hiddenpowerfire", "psyshock", "roost", "surf"],
		randomDoubleBattleMoves: ["dragonpulse", "healpulse", "helpinghand", "lightscreen", "protect", "psychic", "reflect", "tailwind"],
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	latios: {
		randomBattleMoves: ["calmmind", "dracometeor", "hiddenpowerfire", "psyshock", "roost", "trick"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "hiddenpowerfire", "protect", "psyshock", "substitute", "surf", "tailwind", "thunderbolt", "trick"],
		tier: "OU",
		doublesTier: "DOU",
	},
	latiosmega: {
		randomBattleMoves: ["calmmind", "dracometeor", "earthquake", "hiddenpowerfire", "psyshock", "roost"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "hiddenpowerfire", "protect", "psyshock", "substitute", "surf", "tailwind", "thunderbolt"],
		tier: "(OU)",
		doublesTier: "(DOU)",
	},
	kyogre: {
		randomBattleMoves: ["icebeam", "originpulse", "scald", "thunder", "waterspout"],
		randomDoubleBattleMoves: ["calmmind", "icebeam", "muddywater", "originpulse", "protect", "rest", "sleeptalk", "thunder", "waterspout"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	kyogreprimal: {
		randomBattleMoves: ["calmmind", "icebeam", "originpulse", "rest", "scald", "sleeptalk", "thunder", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "icebeam", "muddywater", "originpulse", "protect", "rest", "sleeptalk", "thunder", "waterspout"],
	},
	groudon: {
		randomBattleMoves: ["earthquake", "firepunch", "lavaplume", "roar", "stealthrock", "stoneedge", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["dragonclaw", "firepunch", "precipiceblades", "protect", "rockpolish", "rockslide", "stoneedge", "swordsdance"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	groudonprimal: {
		randomBattleMoves: ["dragontail", "firepunch", "lavaplume", "precipiceblades", "rockpolish", "stealthrock", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["firepunch", "lavaplume", "overheat", "precipiceblades", "protect", "rockpolish", "rockslide", "stoneedge", "swordsdance"],
	},
	rayquaza: {
		randomBattleMoves: ["dracometeor", "dragonclaw", "dragondance", "earthquake", "extremespeed", "outrage", "vcreate"],
		randomDoubleBattleMoves: ["dracometeor", "dragonclaw", "dragondance", "earthquake", "extremespeed", "protect", "tailwind", "vcreate"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	rayquazamega: {
		randomDoubleBattleMoves: ["dragonascent", "dragonclaw", "dragondance", "earthquake", "extremespeed", "protect", "swordsdance", "vcreate"],
		tier: "AG",
		doublesTier: "DUber",
	},
	jirachi: {
		randomBattleMoves: ["bodyslam", "firepunch", "icepunch", "ironhead", "stealthrock", "substitute", "toxic", "uturn", "wish"],
		randomDoubleBattleMoves: ["bodyslam", "followme", "helpinghand", "icywind", "ironhead", "protect", "thunderwave", "trickroom", "uturn", "zenheadbutt"],
		tier: "OU",
		doublesTier: "DUber",
	},
	deoxys: {
		randomBattleMoves: ["extremespeed", "firepunch", "knockoff", "psychoboost", "spikes", "stealthrock", "superpower", "taunt"],
		randomDoubleBattleMoves: ["extremespeed", "firepunch", "icebeam", "knockoff", "protect", "psychoboost", "psyshock", "superpower", "thunderbolt"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysattack: {
		randomBattleMoves: ["extremespeed", "firepunch", "icebeam", "knockoff", "psychoboost", "stealthrock", "superpower"],
		randomDoubleBattleMoves: ["extremespeed", "firepunch", "icebeam", "knockoff", "protect", "psychoboost", "superpower", "thunderbolt"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysdefense: {
		randomBattleMoves: ["knockoff", "recover", "seismictoss", "spikes", "stealthrock", "taunt", "toxic"],
		randomDoubleBattleMoves: ["lightscreen", "protect", "recover", "reflect", "seismictoss", "stealthrock", "taunt", "trickroom"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysspeed: {
		randomBattleMoves: ["knockoff", "magiccoat", "psychoboost", "spikes", "stealthrock", "superpower", "taunt"],
		randomDoubleBattleMoves: ["icebeam", "knockoff", "lightscreen", "protect", "psychoboost", "reflect", "superpower", "taunt"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		randomBattleMoves: ["earthquake", "rockpolish", "stealthrock", "stoneedge", "synthesis", "woodhammer"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockpolish", "rockslide", "stoneedge", "wideguard", "woodhammer"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "PU",
		doublesTier: "NFE",
	},
	infernape: {
		randomBattleMoves: ["closecombat", "fireblast", "flareblitz", "grassknot", "machpunch", "stealthrock", "stoneedge", "uturn"],
		randomDoubleBattleMoves: ["closecombat", "fakeout", "feint", "flareblitz", "grassknot", "heatwave", "machpunch", "protect", "stoneedge", "taunt", "thunderpunch", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "PU",
		doublesTier: "NFE",
	},
	empoleon: {
		randomBattleMoves: ["defog", "flashcannon", "grassknot", "hydropump", "icebeam", "roar", "scald", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["flashcannon", "grassknot", "hiddenpowerelectric", "icebeam", "icywind", "protect", "scald", "surf"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		randomBattleMoves: ["bravebird", "closecombat", "doubleedge", "quickattack", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "closecombat", "doubleedge", "protect", "quickattack", "tailwind", "uturn"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		randomBattleMoves: ["curse", "quickattack", "rest", "return", "stealthrock", "waterfall"],
		randomDoubleBattleMoves: ["curse", "protect", "quickattack", "rest", "return", "waterfall"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		randomBattleMoves: ["endeavor", "knockoff", "stickyweb", "taunt", "toxic", "xscissor"],
		randomDoubleBattleMoves: ["bugbite", "knockoff", "protect", "stickyweb", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		randomBattleMoves: ["crunch", "facade", "icefang", "superpower", "voltswitch", "wildcharge"],
		randomDoubleBattleMoves: ["crunch", "facade", "icefang", "protect", "superpower", "voltswitch", "wildcharge"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		randomBattleMoves: ["crunch", "earthquake", "firepunch", "headsmash", "rockpolish", "rockslide"],
		randomDoubleBattleMoves: ["crunch", "earthquake", "headsmash", "protect", "rockslide", "stoneedge", "zenheadbutt"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		randomBattleMoves: ["metalburst", "protect", "roar", "rockblast", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["guardsplit", "metalburst", "protect", "stealthrock", "stoneedge", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		randomBattleMoves: ["gigadrain", "hiddenpowerrock", "protect", "signalbeam", "synthesis", "toxic"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerice", "hiddenpowerrock", "leafstorm", "protect", "signalbeam", "stringshot"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wormadamsandy: {
		randomBattleMoves: ["earthquake", "protect", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockblast", "stringshot", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	wormadamtrash: {
		randomBattleMoves: ["flashcannon", "protect", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["flashcannon", "protect", "stringshot", "strugglebug"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	mothim: {
		randomBattleMoves: ["airslash", "bugbuzz", "energyball", "quiverdance", "uturn"],
		randomDoubleBattleMoves: ["airslash", "bugbuzz", "gigadrain", "protect", "quiverdance", "roost"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		randomBattleMoves: ["infestation", "protect", "roost", "toxic", "uturn"],
		randomDoubleBattleMoves: ["attackorder", "healorder", "protect", "stringshot", "strugglebug", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pachirisu: {
		randomBattleMoves: ["nuzzle", "superfang", "thunderbolt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["followme", "helpinghand", "nuzzle", "protect", "superfang", "thunderbolt", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		randomBattleMoves: ["aquajet", "brickbreak", "bulkup", "icepunch", "substitute", "taunt", "waterfall"],
		randomDoubleBattleMoves: ["aquajet", "crunch", "icepunch", "protect", "raindance", "switcheroo", "taunt", "waterfall"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		randomBattleMoves: ["dazzlinggleam", "energyball", "healingwish", "hiddenpowerfire", "synthesis"],
		randomDoubleBattleMoves: ["gigadrain", "protect", "solarbeam", "sunnyday", "weatherball"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cherrimsunshine: {
		randomBattleMoves: ["gigadrain", "hiddenpowerice", "solarbeam", "sunnyday", "weatherball"],
		randomDoubleBattleMoves: ["gigadrain", "protect", "solarbeam", "sunnyday", "weatherball"],
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		randomBattleMoves: ["clearsmog", "earthquake", "icebeam", "recover", "scald", "toxic"],
		randomDoubleBattleMoves: ["earthpower", "icebeam", "icywind", "muddywater", "protect", "recover", "scald"],
		tier: "NU",
		doublesTier: "DOU",
	},
	drifloon: {
		tier: "NFE",
	},
	drifblim: {
		randomBattleMoves: ["acrobatics", "destinybond", "hex", "shadowball", "substitute", "willowisp"],
		randomDoubleBattleMoves: ["destinybond", "hiddenpowerfighting", "hypnosis", "protect", "shadowball", "substitute", "thunderbolt", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		randomBattleMoves: ["healingwish", "highjumpkick", "icepunch", "return", "switcheroo"],
		randomDoubleBattleMoves: ["encore", "fakeout", "firepunch", "highjumpkick", "icepunch", "protect", "return", "switcheroo"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lopunnymega: {
		randomBattleMoves: ["fakeout", "highjumpkick", "icepunch", "return", "substitute"],
		randomDoubleBattleMoves: ["encore", "fakeout", "highjumpkick", "icepunch", "protect", "return"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		randomBattleMoves: ["fakeout", "knockoff", "quickattack", "return", "suckerpunch", "uturn"],
		randomDoubleBattleMoves: ["fakeout", "knockoff", "protect", "quickattack", "return", "suckerpunch", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		randomBattleMoves: ["crunch", "defog", "fireblast", "poisonjab", "pursuit", "suckerpunch", "taunt"],
		randomDoubleBattleMoves: ["crunch", "fireblast", "playrough", "poisonjab", "protect", "snarl", "suckerpunch", "taunt"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		randomBattleMoves: ["earthquake", "explosion", "gyroball", "lightscreen", "reflect", "stealthrock", "toxic", "trickroom"],
		randomDoubleBattleMoves: ["earthquake", "explosion", "gyroball", "lightscreen", "protect", "reflect", "trickroom"],
		tier: "RU",
		doublesTier: "DUU",
	},
	chatot: {
		randomBattleMoves: ["boomburst", "chatter", "heatwave", "hiddenpowerground", "nastyplot", "substitute", "uturn"],
		randomDoubleBattleMoves: ["boomburst", "chatter", "encore", "heatwave", "hypervoice", "nastyplot", "protect", "substitute", "uturn"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	spiritomb: {
		randomBattleMoves: ["calmmind", "darkpulse", "psychic", "pursuit", "rest", "shadowsneak", "sleeptalk", "willowisp"],
		randomDoubleBattleMoves: ["darkpulse", "foulplay", "icywind", "painsplit", "protect", "shadowsneak", "snarl", "willowisp"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "PU",
		doublesTier: "NFE",
	},
	garchomp: {
		randomBattleMoves: ["dragonclaw", "earthquake", "fireblast", "firefang", "outrage", "stealthrock", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "protect", "rockslide", "stoneedge", "substitute", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	garchompmega: {
		randomBattleMoves: ["dracometeor", "earthquake", "fireblast", "outrage", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "fireblast", "protect", "rockslide", "stoneedge", "substitute", "swordsdance"],
		tier: "(OU)",
		doublesTier: "(DOU)",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		randomBattleMoves: ["aurasphere", "closecombat", "crunch", "darkpulse", "extremespeed", "flashcannon", "icepunch", "nastyplot", "swordsdance", "vacuumwave"],
		randomDoubleBattleMoves: ["aurasphere", "bulletpunch", "closecombat", "crunch", "darkpulse", "extremespeed", "flashcannon", "followme", "icepunch", "protect", "vacuumwave"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	lucariomega: {
		randomBattleMoves: ["aurasphere", "bulletpunch", "closecombat", "crunch", "darkpulse", "flashcannon", "icepunch", "nastyplot", "swordsdance"],
		randomDoubleBattleMoves: ["aurasphere", "bulletpunch", "closecombat", "crunch", "darkpulse", "extremespeed", "flashcannon", "followme", "icepunch", "protect", "vacuumwave"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		randomBattleMoves: ["earthquake", "slackoff", "stealthrock", "stoneedge", "toxic", "whirlwind"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockslide", "slackoff", "stealthrock", "stoneedge"],
		tier: "OU",
		doublesTier: "DUU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		randomBattleMoves: ["earthquake", "knockoff", "poisonjab", "pursuit", "swordsdance", "taunt", "toxicspikes", "whirlwind"],
		randomDoubleBattleMoves: ["aquatail", "earthquake", "knockoff", "poisonjab", "protect", "snarl", "swordsdance", "taunt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		randomBattleMoves: ["drainpunch", "gunkshot", "icepunch", "substitute", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "gunkshot", "icepunch", "knockoff", "protect", "substitute", "suckerpunch", "swordsdance"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	carnivine: {
		randomBattleMoves: ["knockoff", "powerwhip", "return", "sleeppowder", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["knockoff", "leechseed", "powerwhip", "protect", "ragepowder", "return", "sleeppowder", "substitute", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		randomBattleMoves: ["defog", "icebeam", "scald", "toxic", "uturn"],
		randomDoubleBattleMoves: ["icebeam", "protect", "raindance", "surf", "tailwind", "toxic", "uturn"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		randomBattleMoves: ["blizzard", "earthquake", "focuspunch", "gigadrain", "iceshard", "leechseed", "substitute", "woodhammer"],
		randomDoubleBattleMoves: ["blizzard", "earthquake", "focusblast", "gigadrain", "iceshard", "protect", "woodhammer"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	abomasnowmega: {
		randomBattleMoves: ["blizzard", "earthquake", "gigadrain", "hiddenpowerfire", "iceshard", "woodhammer"],
		randomDoubleBattleMoves: ["blizzard", "earthquake", "focusblast", "gigadrain", "iceshard", "protect", "woodhammer"],
		tier: "RUBL",
		doublesTier: "DUU",
	},
	rotom: {
		randomBattleMoves: ["hiddenpowerice", "painsplit", "shadowball", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["electroweb", "hiddenpowerice", "painsplit", "protect", "shadowball", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	rotomheat: {
		randomBattleMoves: ["hiddenpowerice", "overheat", "painsplit", "thunderbolt", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["electroweb", "hiddenpowerice", "overheat", "painsplit", "protect", "substitute", "thunderbolt", "voltswitch", "willowisp"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	rotomwash: {
		randomBattleMoves: ["hydropump", "painsplit", "thunderbolt", "trick", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["electroweb", "hiddenpowergrass", "hiddenpowerice", "hydropump", "painsplit", "protect", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	rotomfrost: {
		randomBattleMoves: ["blizzard", "painsplit", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["blizzard", "electroweb", "painsplit", "protect", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	rotomfan: {
		randomBattleMoves: ["airslash", "painsplit", "thunderbolt", "voltswitch", "willowisp"],
		randomDoubleBattleMoves: ["airslash", "discharge", "electroweb", "hiddenpowerice", "painsplit", "protect", "substitute", "thunderbolt", "voltswitch", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	rotommow: {
		randomBattleMoves: ["hiddenpowerfire", "hiddenpowerice", "leafstorm", "thunderbolt", "trick", "voltswitch"],
		randomDoubleBattleMoves: ["electroweb", "hiddenpowerfire", "leafstorm", "painsplit", "protect", "substitute", "thunderbolt", "trick", "voltswitch", "willowisp"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	uxie: {
		randomBattleMoves: ["healbell", "knockoff", "psychic", "stealthrock", "thunderwave", "uturn", "yawn"],
		randomDoubleBattleMoves: ["healbell", "helpinghand", "protect", "psyshock", "skillswap", "stealthrock", "thunderbolt", "thunderwave", "uturn", "yawn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	mesprit: {
		randomBattleMoves: ["calmmind", "energyball", "healingwish", "hiddenpowerfire", "icebeam", "psychic", "psyshock", "signalbeam", "stealthrock", "uturn"],
		randomDoubleBattleMoves: ["calmmind", "helpinghand", "icebeam", "knockoff", "protect", "psychic", "substitute", "thunderbolt", "trick", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	azelf: {
		randomBattleMoves: ["dazzlinggleam", "explosion", "fireblast", "knockoff", "nastyplot", "psyshock", "stealthrock", "taunt"],
		randomDoubleBattleMoves: ["dazzlinggleam", "fireblast", "icepunch", "knockoff", "nastyplot", "protect", "psychic", "taunt", "thunderbolt", "uturn", "zenheadbutt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	dialga: {
		randomBattleMoves: ["dracometeor", "fireblast", "flashcannon", "roar", "stealthrock", "thunderbolt", "toxic"],
		randomDoubleBattleMoves: ["aurasphere", "dracometeor", "dragonpulse", "earthpower", "fireblast", "flashcannon", "protect", "thunderbolt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	palkia: {
		randomBattleMoves: ["dracometeor", "dragontail", "fireblast", "hydropump", "spacialrend", "thunderwave"],
		randomDoubleBattleMoves: ["dracometeor", "fireblast", "hydropump", "protect", "spacialrend", "surf", "thunderbolt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	heatran: {
		randomBattleMoves: ["earthpower", "fireblast", "flashcannon", "lavaplume", "protect", "roar", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthpower", "eruption", "heatwave", "protect", "substitute", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	regigigas: {
		randomBattleMoves: ["confuseray", "drainpunch", "knockoff", "return", "substitute", "thunderwave"],
		randomDoubleBattleMoves: ["earthquake", "icywind", "knockoff", "return", "rockslide", "substitute", "thunderwave", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	giratina: {
		randomBattleMoves: ["dragonpulse", "dragontail", "rest", "roar", "shadowball", "sleeptalk", "willowisp"],
		randomDoubleBattleMoves: ["calmmind", "dragonpulse", "dragontail", "icywind", "protect", "shadowball", "tailwind", "willowisp"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	giratinaorigin: {
		randomBattleMoves: ["defog", "dracometeor", "dragontail", "earthquake", "shadowball", "shadowsneak", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["aurasphere", "calmmind", "dracometeor", "dragonpulse", "earthquake", "hiddenpowerfire", "protect", "shadowball", "shadowsneak", "substitute", "tailwind", "willowisp"],
	},
	cresselia: {
		randomBattleMoves: ["calmmind", "icebeam", "moonblast", "moonlight", "psychic", "psyshock", "substitute", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["helpinghand", "icebeam", "icywind", "lightscreen", "moonblast", "moonlight", "protect", "psyshock", "reflect", "skillswap", "thunderwave", "trickroom"],
		tier: "UU",
		doublesTier: "DOU",
	},
	phione: {
		randomBattleMoves: ["healbell", "icebeam", "knockoff", "scald", "toxic", "uturn"],
		randomDoubleBattleMoves: ["helpinghand", "icebeam", "icywind", "protect", "raindance", "rest", "scald", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	manaphy: {
		randomBattleMoves: ["energyball", "icebeam", "surf", "tailglow"],
		randomDoubleBattleMoves: ["energyball", "helpinghand", "icebeam", "icywind", "protect", "scald", "surf", "tailglow"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	darkrai: {
		randomBattleMoves: ["darkpulse", "darkvoid", "focusblast", "nastyplot", "sludgebomb", "substitute"],
		randomDoubleBattleMoves: ["darkpulse", "focusblast", "nastyplot", "protect", "snarl", "substitute"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	shaymin: {
		randomBattleMoves: ["airslash", "earthpower", "leechseed", "psychic", "rest", "seedflare", "substitute"],
		randomDoubleBattleMoves: ["airslash", "earthpower", "hiddenpowerfire", "leechseed", "protect", "rest", "seedflare", "substitute", "tailwind"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	shayminsky: {
		randomBattleMoves: ["airslash", "earthpower", "hiddenpowerice", "leechseed", "seedflare", "substitute"],
		randomDoubleBattleMoves: ["airslash", "earthpower", "hiddenpowerice", "leechseed", "protect", "rest", "seedflare", "substitute", "tailwind"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceus: {
		randomBattleMoves: ["earthquake", "extremespeed", "recover", "shadowclaw", "swordsdance"],
		randomDoubleBattleMoves: ["earthquake", "extremespeed", "protect", "recover", "shadowclaw", "swordsdance"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	arceusbug: {
		randomBattleMoves: ["earthquake", "ironhead", "recover", "stoneedge", "swordsdance", "xscissor"],
		randomDoubleBattleMoves: ["earthquake", "ironhead", "protect", "recover", "stoneedge", "swordsdance", "xscissor"],
	},
	arceusdark: {
		randomBattleMoves: ["calmmind", "fireblast", "judgment", "recover", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "judgment", "protect", "recover", "safeguard", "snarl", "willowisp"],
	},
	arceusdragon: {
		randomBattleMoves: ["defog", "earthquake", "extremespeed", "fireblast", "judgment", "outrage", "recover", "swordsdance", "willowisp"],
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "extremespeed", "protect", "recover", "swordsdance"],
	},
	arceuselectric: {
		randomBattleMoves: ["calmmind", "earthpower", "icebeam", "judgment", "recover"],
		randomDoubleBattleMoves: ["calmmind", "icebeam", "judgment", "protect", "recover"],
	},
	arceusfairy: {
		randomBattleMoves: ["calmmind", "defog", "earthpower", "judgment", "recover", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["calmmind", "earthpower", "judgment", "protect", "recover", "thunderbolt", "willowisp"],
	},
	arceusfighting: {
		randomBattleMoves: ["calmmind", "icebeam", "judgment", "recover", "shadowball", "stoneedge"],
		randomDoubleBattleMoves: ["calmmind", "icebeam", "judgment", "protect", "recover", "shadowball", "willowisp"],
	},
	arceusfire: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "recover", "thunderbolt"],
		randomDoubleBattleMoves: ["calmmind", "heatwave", "judgment", "protect", "recover", "thunderbolt", "willowisp"],
	},
	arceusflying: {
		randomBattleMoves: ["calmmind", "earthpower", "fireblast", "judgment", "recover", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "judgment", "protect", "recover", "safeguard", "substitute", "tailwind"],
	},
	arceusghost: {
		randomBattleMoves: ["brickbreak", "defog", "extremespeed", "judgment", "recover", "shadowclaw", "shadowforce", "swordsdance", "toxic"],
		randomDoubleBattleMoves: ["brickbreak", "calmmind", "focusblast", "judgment", "protect", "recover", "shadowforce", "swordsdance", "willowisp"],
	},
	arceusgrass: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "judgment", "recover"],
		randomDoubleBattleMoves: ["calmmind", "earthpower", "icebeam", "judgment", "protect", "recover", "safeguard", "thunderwave"],
	},
	arceusground: {
		randomBattleMoves: ["earthquake", "icebeam", "judgment", "recover", "stealthrock", "stoneedge", "swordsdance", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "earthquake", "icebeam", "judgment", "protect", "recover", "rockslide", "stoneedge", "swordsdance"],
	},
	arceusice: {
		randomBattleMoves: ["calmmind", "fireblast", "judgment", "recover", "thunderbolt"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "icywind", "judgment", "protect", "recover", "thunderbolt"],
	},
	arceuspoison: {
		randomBattleMoves: ["calmmind", "defog", "fireblast", "icebeam", "recover", "sludgebomb"],
		randomDoubleBattleMoves: ["calmmind", "earthpower", "heatwave", "judgment", "protect", "recover", "sludgebomb", "willowisp"],
	},
	arceuspsychic: {
		randomBattleMoves: ["calmmind", "fireblast", "icebeam", "judgment", "recover", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "judgment", "protect", "psyshock", "recover", "willowisp"],
	},
	arceusrock: {
		randomBattleMoves: ["earthquake", "judgment", "recover", "stealthrock", "stoneedge", "swordsdance", "willowisp"],
		randomDoubleBattleMoves: ["earthquake", "protect", "recover", "rockslide", "stoneedge", "swordsdance"],
	},
	arceussteel: {
		randomBattleMoves: ["defog", "earthquake", "ironhead", "judgment", "recover", "roar", "stoneedge", "swordsdance", "willowisp"],
		randomDoubleBattleMoves: ["calmmind", "judgment", "protect", "recover", "willowisp"],
	},
	arceuswater: {
		randomBattleMoves: ["calmmind", "defog", "icebeam", "judgment", "recover", "toxic"],
		randomDoubleBattleMoves: ["calmmind", "fireblast", "icebeam", "icywind", "judgment", "protect", "recover", "surf"],
	},
	victini: {
		randomBattleMoves: ["blueflare", "boltstrike", "energyball", "glaciate", "uturn", "vcreate", "zenheadbutt"],
		randomDoubleBattleMoves: ["blueflare", "boltstrike", "focusblast", "protect", "psychic", "uturn", "vcreate"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	snivy: {
		tier: "LC",
	},
	servine: {
		tier: "NFE",
	},
	serperior: {
		randomBattleMoves: ["dragonpulse", "glare", "hiddenpowerfire", "leafstorm", "leechseed", "substitute"],
		randomDoubleBattleMoves: ["dragonpulse", "hiddenpowerfire", "leafstorm", "protect", "substitute", "taunt"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	tepig: {
		tier: "LC",
	},
	pignite: {
		tier: "NFE",
	},
	emboar: {
		randomBattleMoves: ["fireblast", "flareblitz", "grassknot", "headsmash", "suckerpunch", "superpower", "wildcharge"],
		randomDoubleBattleMoves: ["flamecharge", "flareblitz", "headsmash", "heatwave", "protect", "rockslide", "superpower", "wildcharge"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	oshawott: {
		tier: "LC",
	},
	dewott: {
		tier: "NFE",
	},
	samurott: {
		randomBattleMoves: ["aquajet", "grassknot", "hydropump", "icebeam", "megahorn", "superpower", "swordsdance", "waterfall"],
		randomDoubleBattleMoves: ["aquajet", "helpinghand", "hiddenpowergrass", "hydropump", "icebeam", "protect", "scald", "taunt"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	patrat: {
		tier: "LC",
	},
	watchog: {
		randomBattleMoves: ["hypnosis", "knockoff", "return", "substitute", "superfang", "swordsdance"],
		randomDoubleBattleMoves: ["hypnosis", "knockoff", "protect", "return", "substitute", "superfang", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	lillipup: {
		tier: "LC",
	},
	herdier: {
		tier: "NFE",
	},
	stoutland: {
		randomBattleMoves: ["crunch", "icefang", "return", "superpower", "wildcharge"],
		randomDoubleBattleMoves: ["crunch", "icefang", "protect", "return", "superpower", "wildcharge"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	purrloin: {
		tier: "LC",
	},
	liepard: {
		randomBattleMoves: ["copycat", "darkpulse", "encore", "knockoff", "nastyplot", "playrough", "substitute", "thunderwave", "uturn"],
		randomDoubleBattleMoves: ["encore", "fakeout", "knockoff", "playrough", "protect", "substitute", "suckerpunch", "thunderwave", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pansage: {
		tier: "LC",
	},
	simisage: {
		randomBattleMoves: ["focusblast", "gigadrain", "hiddenpowerice", "knockoff", "leafstorm", "nastyplot", "substitute", "superpower"],
		randomDoubleBattleMoves: ["focusblast", "gigadrain", "helpinghand", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "nastyplot", "protect", "substitute", "synthesis", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pansear: {
		tier: "LC",
	},
	simisear: {
		randomBattleMoves: ["fireblast", "focusblast", "grassknot", "hiddenpowerrock", "nastyplot", "substitute"],
		randomDoubleBattleMoves: ["fireblast", "focusblast", "grassknot", "heatwave", "hiddenpowerground", "nastyplot", "protect", "substitute", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	panpour: {
		tier: "LC",
	},
	simipour: {
		randomBattleMoves: ["focusblast", "hydropump", "icebeam", "nastyplot", "substitute"],
		randomDoubleBattleMoves: ["helpinghand", "hydropump", "icebeam", "nastyplot", "protect", "substitute", "surf", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	munna: {
		tier: "LC",
	},
	musharna: {
		randomBattleMoves: ["calmmind", "healbell", "moonlight", "psychic", "psyshock", "signalbeam", "thunderwave"],
		randomDoubleBattleMoves: ["healbell", "helpinghand", "hiddenpowerfighting", "moonlight", "protect", "psychic", "psyshock", "signalbeam", "thunderwave", "trickroom"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	pidove: {
		tier: "LC",
	},
	tranquill: {
		tier: "NFE",
	},
	unfezant: {
		randomBattleMoves: ["hypnosis", "nightslash", "pluck", "return", "roost", "tailwind", "uturn"],
		randomDoubleBattleMoves: ["nightslash", "pluck", "protect", "return", "roost", "tailwind", "taunt", "uturn"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	blitzle: {
		tier: "LC",
	},
	zebstrika: {
		randomBattleMoves: ["hiddenpowergrass", "hiddenpowerice", "overheat", "thunderbolt", "voltswitch", "wildcharge"],
		randomDoubleBattleMoves: ["hiddenpowergrass", "overheat", "protect", "voltswitch", "wildcharge"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	roggenrola: {
		tier: "LC",
	},
	boldore: {
		tier: "NFE",
	},
	gigalith: {
		randomBattleMoves: ["earthquake", "explosion", "stealthrock", "stoneedge", "superpower"],
		randomDoubleBattleMoves: ["autotomize", "earthquake", "explosion", "protect", "rockslide", "stealthrock", "stoneedge", "superpower", "wideguard"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	woobat: {
		tier: "LC",
	},
	swoobat: {
		randomBattleMoves: ["airslash", "calmmind", "heatwave", "roost", "storedpower", "substitute"],
		randomDoubleBattleMoves: ["airslash", "calmmind", "gigadrain", "heatwave", "protect", "psychic", "tailwind"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	drilbur: {
		tier: "LC",
	},
	excadrill: {
		randomBattleMoves: ["earthquake", "ironhead", "rapidspin", "rockslide", "swordsdance"],
		randomDoubleBattleMoves: ["drillrun", "earthquake", "ironhead", "protect", "rockslide", "substitute", "swordsdance"],
		tier: "OU",
		doublesTier: "DUU",
	},
	audino: {
		randomBattleMoves: ["doubleedge", "encore", "healbell", "knockoff", "protect", "toxic", "wish"],
		randomDoubleBattleMoves: ["doubleedge", "healbell", "healpulse", "helpinghand", "lightscreen", "protect", "reflect", "thunderwave", "trickroom"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	audinomega: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "fireblast", "healbell", "protect", "wish"],
		randomDoubleBattleMoves: ["dazzlinggleam", "healbell", "healpulse", "helpinghand", "hypervoice", "protect", "thunderwave", "trickroom"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	timburr: {
		tier: "LC",
	},
	gurdurr: {
		tier: "NU",
		doublesTier: "NFE",
	},
	conkeldurr: {
		randomBattleMoves: ["bulkup", "drainpunch", "facade", "icepunch", "knockoff", "machpunch"],
		randomDoubleBattleMoves: ["drainpunch", "icepunch", "knockoff", "machpunch", "protect", "wideguard"],
		tier: "UUBL",
		doublesTier: "DOU",
	},
	tympole: {
		tier: "LC",
	},
	palpitoad: {
		tier: "NFE",
	},
	seismitoad: {
		randomBattleMoves: ["earthquake", "hydropump", "knockoff", "raindance", "scald", "sludgebomb", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["earthquake", "hiddenpowerelectric", "hydropump", "icywind", "muddywater", "protect", "sludgebomb"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	throh: {
		randomBattleMoves: ["bulkup", "circlethrow", "icepunch", "knockoff", "rest", "sleeptalk", "stormthrow"],
		randomDoubleBattleMoves: ["circlethrow", "helpinghand", "icepunch", "knockoff", "protect", "stormthrow", "wideguard"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	sawk: {
		randomBattleMoves: ["bulkup", "closecombat", "earthquake", "icepunch", "knockoff", "poisonjab"],
		randomDoubleBattleMoves: ["closecombat", "icepunch", "knockoff", "protect", "rockslide"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	sewaddle: {
		tier: "LC",
	},
	swadloon: {
		tier: "NFE",
	},
	leavanny: {
		randomBattleMoves: ["knockoff", "leafblade", "stickyweb", "swordsdance", "xscissor"],
		randomDoubleBattleMoves: ["leafblade", "poisonjab", "protect", "stickyweb", "swordsdance", "xscissor"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	venipede: {
		tier: "LC",
	},
	whirlipede: {
		tier: "NFE",
	},
	scolipede: {
		randomBattleMoves: ["earthquake", "megahorn", "poisonjab", "protect", "rockslide", "spikes", "swordsdance", "toxicspikes"],
		randomDoubleBattleMoves: ["aquatail", "megahorn", "poisonjab", "protect", "rockslide", "substitute", "superpower", "swordsdance"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	cottonee: {
		tier: "LC",
	},
	whimsicott: {
		randomBattleMoves: ["encore", "energyball", "leechseed", "memento", "moonblast", "stunspore", "tailwind", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["dazzlinggleam", "encore", "gigadrain", "helpinghand", "leechseed", "moonblast", "protect", "stunspore", "substitute", "tailwind", "taunt", "uturn"],
		tier: "UU",
		doublesTier: "DOU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "hiddenpowerrock", "petaldance", "quiverdance", "sleeppowder"],
		randomDoubleBattleMoves: ["gigadrain", "helpinghand", "hiddenpowerfire", "hiddenpowerice", "hiddenpowerrock", "petaldance", "protect", "quiverdance", "sleeppowder"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	basculin: {
		randomBattleMoves: ["aquajet", "crunch", "superpower", "waterfall", "zenheadbutt"],
		randomDoubleBattleMoves: ["aquajet", "crunch", "doubleedge", "protect", "superpower", "waterfall"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	basculinbluestriped: {
		randomBattleMoves: ["aquajet", "crunch", "superpower", "waterfall", "zenheadbutt"],
		randomDoubleBattleMoves: ["aquajet", "crunch", "doubleedge", "protect", "superpower", "waterfall"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "NFE",
	},
	krookodile: {
		randomBattleMoves: ["earthquake", "knockoff", "pursuit", "stealthrock", "stoneedge", "superpower"],
		randomDoubleBattleMoves: ["earthquake", "knockoff", "protect", "stoneedge", "superpower"],
		tier: "UU",
		doublesTier: "DUU",
	},
	darumaka: {
		tier: "LC",
	},
	darmanitan: {
		randomBattleMoves: ["earthquake", "flareblitz", "rockslide", "superpower", "uturn"],
		randomDoubleBattleMoves: ["earthquake", "firepunch", "flareblitz", "protect", "rockslide", "superpower", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	maractus: {
		randomBattleMoves: ["gigadrain", "hiddenpowerfire", "leechseed", "spikes", "spikyshield", "suckerpunch", "toxic"],
		randomDoubleBattleMoves: ["gigadrain", "grassyterrain", "helpinghand", "hiddenpowerfire", "leechseed", "spikyshield", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	dwebble: {
		tier: "LC",
	},
	crustle: {
		randomBattleMoves: ["earthquake", "shellsmash", "spikes", "stealthrock", "stoneedge", "xscissor"],
		randomDoubleBattleMoves: ["earthquake", "protect", "rockslide", "shellsmash", "stoneedge", "xscissor"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	scraggy: {
		tier: "LC",
	},
	scrafty: {
		randomBattleMoves: ["bulkup", "dragondance", "drainpunch", "highjumpkick", "icepunch", "knockoff", "rest"],
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "icepunch", "knockoff", "protect", "stoneedge"],
		tier: "RU",
		doublesTier: "DOU",
	},
	sigilyph: {
		randomBattleMoves: ["cosmicpower", "psychoshift", "roost", "storedpower"],
		randomDoubleBattleMoves: ["airslash", "energyball", "heatwave", "icebeam", "protect", "psyshock", "shadowball", "tailwind"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	yamask: {
		tier: "LC",
	},
	cofagrigus: {
		randomBattleMoves: ["haze", "hiddenpowerfighting", "nastyplot", "painsplit", "shadowball", "toxicspikes", "trickroom", "willowisp"],
		randomDoubleBattleMoves: ["hiddenpowerfighting", "nastyplot", "painsplit", "protect", "shadowball", "trickroom", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	tirtouga: {
		tier: "LC",
	},
	carracosta: {
		randomBattleMoves: ["aquajet", "earthquake", "hydropump", "shellsmash", "stoneedge"],
		randomDoubleBattleMoves: ["aquajet", "earthquake", "protect", "rockslide", "shellsmash", "stoneedge", "waterfall", "wideguard"],
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	archen: {
		tier: "LC",
	},
	archeops: {
		randomBattleMoves: ["acrobatics", "aquatail", "earthquake", "endeavor", "headsmash", "stoneedge", "uturn"],
		randomDoubleBattleMoves: ["acrobatics", "earthquake", "protect", "rockslide", "stoneedge", "tailwind", "taunt", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	trubbish: {
		tier: "LC",
	},
	garbodor: {
		randomBattleMoves: ["drainpunch", "gunkshot", "haze", "painsplit", "spikes", "toxic", "toxicspikes"],
		randomDoubleBattleMoves: ["drainpunch", "explosion", "gunkshot", "painsplit", "protect", "rockblast", "seedbomb"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	zorua: {
		tier: "LC",
	},
	zoroark: {
		randomBattleMoves: ["darkpulse", "flamethrower", "focusblast", "nastyplot", "sludgebomb", "trick"],
		randomDoubleBattleMoves: ["darkpulse", "flamethrower", "focusblast", "knockoff", "nastyplot", "protect", "suckerpunch", "uturn"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	minccino: {
		tier: "LC",
	},
	cinccino: {
		randomBattleMoves: ["bulletseed", "knockoff", "rockblast", "tailslap", "uturn"],
		randomDoubleBattleMoves: ["aquatail", "bulletseed", "knockoff", "protect", "rockblast", "tailslap", "uturn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gothita: {
		tier: "LC",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		randomBattleMoves: ["calmmind", "hiddenpowerfighting", "psychic", "rest", "sleeptalk", "toxic"],
		randomDoubleBattleMoves: ["energyball", "healpulse", "hiddenpowerfighting", "lightscreen", "protect", "psychic", "psyshock", "reflect", "shadowball", "taunt", "thunderbolt", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	solosis: {
		tier: "LC",
	},
	duosion: {
		tier: "NFE",
	},
	reuniclus: {
		randomBattleMoves: ["calmmind", "focusblast", "psychic", "psyshock", "recover", "shadowball", "trickroom"],
		randomDoubleBattleMoves: ["energyball", "focusblast", "helpinghand", "hiddenpowerfire", "protect", "psychic", "psyshock", "shadowball", "trickroom"],
		tier: "UU",
		doublesTier: "DUU",
	},
	ducklett: {
		tier: "LC",
	},
	swanna: {
		randomBattleMoves: ["airslash", "defog", "hurricane", "icebeam", "raindance", "roost", "scald"],
		randomDoubleBattleMoves: ["airslash", "hurricane", "icebeam", "protect", "raindance", "roost", "scald", "surf", "tailwind"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	vanillite: {
		tier: "LC",
	},
	vanillish: {
		tier: "NFE",
	},
	vanilluxe: {
		randomBattleMoves: ["autotomize", "explosion", "flashcannon", "freezedry", "hiddenpowerground", "icebeam"],
		randomDoubleBattleMoves: ["autotomize", "flashcannon", "freezedry", "hiddenpowerground", "icebeam", "protect", "taunt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	deerling: {
		tier: "LC",
	},
	sawsbuck: {
		randomBattleMoves: ["hornleech", "jumpkick", "return", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["hornleech", "jumpkick", "protect", "return", "substitute", "swordsdance", "synthesis"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	emolga: {
		randomBattleMoves: ["acrobatics", "encore", "knockoff", "roost", "thunderbolt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["airslash", "encore", "helpinghand", "protect", "roost", "substitute", "tailwind", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	karrablast: {
		tier: "LC",
	},
	escavalier: {
		randomBattleMoves: ["drillrun", "ironhead", "knockoff", "megahorn", "pursuit", "swordsdance"],
		randomDoubleBattleMoves: ["drillrun", "ironhead", "knockoff", "megahorn", "protect", "swordsdance"],
		tier: "RU",
		doublesTier: "DUU",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		randomBattleMoves: ["foulplay", "gigadrain", "hiddenpowerfire", "sludgebomb", "spore", "synthesis"],
		randomDoubleBattleMoves: ["gigadrain", "hiddenpowerfire", "protect", "ragepowder", "sludgebomb", "spore", "stunspore", "synthesis"],
		tier: "OU",
		doublesTier: "DOU",
	},
	frillish: {
		tier: "LC",
	},
	jellicent: {
		randomBattleMoves: ["icebeam", "recover", "scald", "shadowball", "taunt", "toxic", "willowisp"],
		randomDoubleBattleMoves: ["icebeam", "icywind", "protect", "recover", "scald", "shadowball", "trickroom", "waterspout", "willowisp"],
		tier: "RU",
		doublesTier: "DUU",
	},
	alomomola: {
		randomBattleMoves: ["knockoff", "protect", "scald", "toxic", "wish"],
		randomDoubleBattleMoves: ["helpinghand", "icywind", "knockoff", "protect", "scald", "wideguard", "wish"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	joltik: {
		tier: "LC",
	},
	galvantula: {
		randomBattleMoves: ["bugbuzz", "gigadrain", "hiddenpowerice", "stickyweb", "thunder", "voltswitch"],
		randomDoubleBattleMoves: ["bugbuzz", "gigadrain", "hiddenpowerice", "protect", "stickyweb", "thunder", "voltswitch"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	ferroseed: {
		tier: "NU",
		doublesTier: "LC",
	},
	ferrothorn: {
		randomBattleMoves: ["gyroball", "knockoff", "leechseed", "powerwhip", "protect", "spikes", "stealthrock"],
		randomDoubleBattleMoves: ["gyroball", "knockoff", "leechseed", "powerwhip", "protect", "stealthrock"],
		tier: "OU",
		doublesTier: "DOU",
	},
	klink: {
		tier: "LC",
	},
	klang: {
		tier: "NFE",
	},
	klinklang: {
		randomBattleMoves: ["geargrind", "return", "shiftgear", "substitute", "wildcharge"],
		randomDoubleBattleMoves: ["geargrind", "protect", "return", "shiftgear", "wildcharge"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	tynamo: {
		tier: "LC",
	},
	eelektrik: {
		tier: "NFE",
	},
	eelektross: {
		randomBattleMoves: ["flamethrower", "gigadrain", "hiddenpowerice", "knockoff", "superpower", "thunderbolt", "uturn"],
		randomDoubleBattleMoves: ["flamethrower", "gigadrain", "knockoff", "protect", "thunderbolt", "uturn", "voltswitch"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	elgyem: {
		tier: "LC",
	},
	beheeyem: {
		randomBattleMoves: ["hiddenpowerfighting", "nastyplot", "psychic", "psyshock", "signalbeam", "thunderbolt", "trick", "trickroom"],
		randomDoubleBattleMoves: ["hiddenpowerfighting", "nastyplot", "protect", "psychic", "recover", "signalbeam", "thunderbolt", "trick", "trickroom"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	litwick: {
		tier: "LC",
	},
	lampent: {
		tier: "NFE",
	},
	chandelure: {
		randomBattleMoves: ["calmmind", "energyball", "fireblast", "hiddenpowerground", "painsplit", "shadowball", "substitute", "trick"],
		randomDoubleBattleMoves: ["energyball", "heatwave", "hiddenpowerice", "overheat", "protect", "shadowball", "trick"],
		tier: "UU",
		doublesTier: "DUU",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "NFE",
	},
	haxorus: {
		randomBattleMoves: ["dragondance", "earthquake", "outrage", "poisonjab", "swordsdance"],
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "earthquake", "poisonjab", "protect", "substitute", "swordsdance"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		randomBattleMoves: ["aquajet", "iciclecrash", "nightslash", "stoneedge", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["aquajet", "iciclecrash", "nightslash", "protect", "stoneedge", "superpower", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	cryogonal: {
		randomBattleMoves: ["freezedry", "haze", "hiddenpowerground", "icebeam", "rapidspin", "recover", "toxic"],
		randomDoubleBattleMoves: ["freezedry", "hiddenpowerground", "icebeam", "icywind", "protect", "recover", "reflect"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shelmet: {
		tier: "LC",
	},
	accelgor: {
		randomBattleMoves: ["bugbuzz", "encore", "energyball", "focusblast", "hiddenpowerrock", "spikes", "yawn"],
		randomDoubleBattleMoves: ["bugbuzz", "encore", "focusblast", "gigadrain", "hiddenpowerrock", "protect", "sludgebomb", "yawn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	stunfisk: {
		randomBattleMoves: ["discharge", "earthpower", "foulplay", "rest", "sleeptalk", "stealthrock", "toxic"],
		randomDoubleBattleMoves: ["discharge", "earthpower", "electroweb", "protect", "scald", "stealthrock"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	mienfoo: {
		tier: "LC",
	},
	mienshao: {
		randomBattleMoves: ["fakeout", "highjumpkick", "knockoff", "poisonjab", "stoneedge", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "feint", "highjumpkick", "knockoff", "protect", "stoneedge", "swordsdance", "uturn", "wideguard"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	druddigon: {
		randomBattleMoves: ["dragontail", "earthquake", "firepunch", "glare", "gunkshot", "outrage", "stealthrock", "suckerpunch", "taunt"],
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "firepunch", "glare", "protect", "suckerpunch", "superpower", "thunderpunch"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	golett: {
		tier: "LC",
	},
	golurk: {
		randomBattleMoves: ["dynamicpunch", "earthquake", "icepunch", "rockpolish", "shadowpunch", "stealthrock", "stoneedge"],
		randomDoubleBattleMoves: ["dynamicpunch", "earthquake", "icepunch", "protect", "rockpolish", "shadowpunch", "stoneedge"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pawniard: {
		tier: "PU",
		doublesTier: "LC",
	},
	bisharp: {
		randomBattleMoves: ["ironhead", "knockoff", "lowkick", "suckerpunch", "swordsdance"],
		randomDoubleBattleMoves: ["brickbreak", "ironhead", "knockoff", "protect", "substitute", "suckerpunch", "swordsdance"],
		tier: "OU",
		doublesTier: "DOU",
	},
	bouffalant: {
		randomBattleMoves: ["earthquake", "headcharge", "megahorn", "stoneedge", "superpower", "swordsdance"],
		randomDoubleBattleMoves: ["earthquake", "headcharge", "megahorn", "protect", "stoneedge", "superpower", "swordsdance"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	rufflet: {
		tier: "LC",
	},
	braviary: {
		randomBattleMoves: ["bravebird", "bulkup", "return", "roost", "substitute", "superpower", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "bulkup", "protect", "return", "rockslide", "roost", "skydrop", "superpower", "tailwind", "uturn"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	vullaby: {
		tier: "PU",
		doublesTier: "LC",
	},
	mandibuzz: {
		randomBattleMoves: ["bravebird", "defog", "foulplay", "roost", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["bravebird", "knockoff", "protect", "roost", "snarl", "tailwind", "taunt", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	heatmor: {
		randomBattleMoves: ["fireblast", "gigadrain", "knockoff", "suckerpunch", "superpower"],
		randomDoubleBattleMoves: ["fireblast", "focusblast", "gigadrain", "heatwave", "protect", "suckerpunch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	durant: {
		randomBattleMoves: ["honeclaws", "ironhead", "stoneedge", "superpower", "xscissor"],
		randomDoubleBattleMoves: ["honeclaws", "ironhead", "protect", "rockslide", "superpower", "xscissor"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "NFE",
	},
	hydreigon: {
		randomBattleMoves: ["darkpulse", "dracometeor", "fireblast", "flashcannon", "roost", "superpower", "uturn"],
		randomDoubleBattleMoves: ["darkpulse", "dracometeor", "dragonpulse", "earthpower", "fireblast", "flashcannon", "protect", "roost", "superpower", "tailwind", "uturn"],
		tier: "UU",
		doublesTier: "DOU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		randomBattleMoves: ["bugbuzz", "fierydance", "fireblast", "gigadrain", "hiddenpowerice", "quiverdance", "roost"],
		randomDoubleBattleMoves: ["bugbuzz", "fierydance", "fireblast", "gigadrain", "heatwave", "hiddenpowerice", "protect", "quiverdance", "ragepowder", "roost", "tailwind", "willowisp"],
		tier: "UUBL",
		doublesTier: "DUU",
	},
	cobalion: {
		randomBattleMoves: ["closecombat", "ironhead", "stealthrock", "stoneedge", "substitute", "swordsdance", "taunt", "voltswitch"],
		randomDoubleBattleMoves: ["closecombat", "ironhead", "protect", "stoneedge", "substitute", "swordsdance", "thunderwave"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	terrakion: {
		randomBattleMoves: ["closecombat", "earthquake", "quickattack", "stoneedge", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "earthquake", "protect", "rockslide", "stoneedge", "substitute"],
		tier: "UUBL",
		doublesTier: "DOU",
	},
	virizion: {
		randomBattleMoves: ["closecombat", "leafblade", "stoneedge", "swordsdance"],
		randomDoubleBattleMoves: ["closecombat", "leafblade", "protect", "stoneedge", "swordsdance", "synthesis", "taunt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	tornadus: {
		randomBattleMoves: ["acrobatics", "bulkup", "knockoff", "rest", "sleeptalk", "superpower", "tailwind"],
		randomDoubleBattleMoves: ["airslash", "focusblast", "heatwave", "hurricane", "protect", "skydrop", "substitute", "superpower", "tailwind", "taunt", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
	},
	tornadustherian: {
		randomBattleMoves: ["heatwave", "hurricane", "knockoff", "superpower", "taunt", "uturn"],
		randomDoubleBattleMoves: ["airslash", "focusblast", "heatwave", "hurricane", "protect", "skydrop", "tailwind", "taunt", "uturn"],
		tier: "OU",
		doublesTier: "(DUU)",
	},
	thundurus: {
		randomBattleMoves: ["focusblast", "hiddenpowerflying", "hiddenpowerice", "knockoff", "nastyplot", "substitute", "taunt", "thunderbolt", "thunderwave"],
		randomDoubleBattleMoves: ["focusblast", "hiddenpowerflying", "hiddenpowerice", "knockoff", "nastyplot", "protect", "substitute", "taunt", "thunderbolt", "thunderwave"],
		tier: "OU",
		doublesTier: "DOU",
	},
	thundurustherian: {
		randomBattleMoves: ["focusblast", "hiddenpowerflying", "hiddenpowerice", "nastyplot", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["focusblast", "hiddenpowerflying", "hiddenpowerice", "nastyplot", "protect", "thunderbolt", "voltswitch"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	reshiram: {
		randomBattleMoves: ["blueflare", "dracometeor", "earthpower", "roost", "stoneedge", "toxic"],
		randomDoubleBattleMoves: ["blueflare", "dracometeor", "dragonpulse", "flamecharge", "heatwave", "protect", "roost", "tailwind"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	zekrom: {
		randomBattleMoves: ["boltstrike", "dracometeor", "dragonclaw", "honeclaws", "outrage", "roost", "substitute", "voltswitch"],
		randomDoubleBattleMoves: ["boltstrike", "dracometeor", "dragonclaw", "fusionbolt", "honeclaws", "protect", "roost", "substitute", "tailwind", "voltswitch"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	landorus: {
		randomBattleMoves: ["calmmind", "earthpower", "focusblast", "knockoff", "psychic", "rockpolish", "rockslide", "sludgewave", "stealthrock"],
		randomDoubleBattleMoves: ["earthpower", "focusblast", "hiddenpowerice", "protect", "psychic", "rockslide", "sludgebomb"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	landorustherian: {
		randomBattleMoves: ["earthquake", "rockpolish", "stealthrock", "stoneedge", "superpower", "swordsdance", "uturn"],
		randomDoubleBattleMoves: ["earthquake", "knockoff", "protect", "rockslide", "stoneedge", "superpower", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
	},
	kyurem: {
		randomBattleMoves: ["dracometeor", "earthpower", "focusblast", "icebeam", "outrage", "roost", "substitute"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "earthpower", "focusblast", "glaciate", "icebeam", "protect", "roost", "substitute"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	kyuremblack: {
		randomBattleMoves: ["dragonclaw", "earthpower", "fusionbolt", "icebeam", "outrage", "roost", "substitute"],
		randomDoubleBattleMoves: ["dragonclaw", "earthpower", "fusionbolt", "honeclaws", "icebeam", "protect", "roost", "substitute"],
		tier: "OU",
		doublesTier: "DOU",
	},
	kyuremwhite: {
		randomBattleMoves: ["dracometeor", "earthpower", "focusblast", "fusionflare", "icebeam", "roost", "toxic"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "earthpower", "focusblast", "fusionflare", "icebeam", "protect", "roost"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	keldeo: {
		randomBattleMoves: ["calmmind", "hiddenpowerelectric", "hydropump", "icywind", "scald", "secretsword", "substitute"],
		randomDoubleBattleMoves: ["hiddenpowerelectric", "hiddenpowerflying", "hydropump", "icywind", "protect", "secretsword", "substitute", "surf", "taunt"],
		tier: "OU",
		doublesTier: "DOU",
	},
	keldeoresolute: {
		tier: "OU",
		doublesTier: "DOU",
	},
	meloetta: {
		randomBattleMoves: ["calmmind", "focusblast", "hypervoice", "psyshock", "shadowball", "trick", "uturn"],
		randomDoubleBattleMoves: ["calmmind", "focusblast", "hypervoice", "protect", "psyshock", "shadowball", "thunderbolt"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	meloettapirouette: {
		randomBattleMoves: ["closecombat", "knockoff", "relicsong", "return"],
		randomDoubleBattleMoves: ["closecombat", "knockoff", "protect", "relicsong", "return"],
	},
	genesect: {
		randomBattleMoves: ["blazekick", "extremespeed", "flamethrower", "icebeam", "ironhead", "shiftgear", "technoblast", "thunderbolt", "uturn"],
		randomDoubleBattleMoves: ["blazekick", "bugbuzz", "extremespeed", "flamethrower", "icebeam", "ironhead", "protect", "shiftgear", "thunderbolt", "uturn"],
		tier: "Uber",
		doublesTier: "DUU",
	},
	genesectburn: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	genesectchill: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	genesectdouse: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	genesectshock: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	chespin: {
		tier: "LC",
	},
	quilladin: {
		tier: "NFE",
	},
	chesnaught: {
		randomBattleMoves: ["drainpunch", "leechseed", "spikes", "spikyshield", "synthesis", "woodhammer"],
		randomDoubleBattleMoves: ["hammerarm", "leechseed", "rockslide", "spikyshield", "stoneedge", "synthesis", "woodhammer"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	fennekin: {
		tier: "LC",
	},
	braixen: {
		tier: "NFE",
	},
	delphox: {
		randomBattleMoves: ["calmmind", "fireblast", "grassknot", "psyshock", "shadowball", "switcheroo"],
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "fireblast", "grassknot", "heatwave", "protect", "psyshock", "shadowball", "switcheroo"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	froakie: {
		tier: "LC",
	},
	frogadier: {
		tier: "NFE",
	},
	greninja: {
		randomBattleMoves: ["gunkshot", "hydropump", "icebeam", "spikes", "taunt", "toxicspikes", "uturn"],
		randomDoubleBattleMoves: ["darkpulse", "hydropump", "icebeam", "matblock", "protect", "surf", "taunt", "uturn"],
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	bunnelby: {
		tier: "LC",
	},
	diggersby: {
		randomBattleMoves: ["agility", "earthquake", "knockoff", "quickattack", "return", "swordsdance", "uturn", "wildcharge"],
		randomDoubleBattleMoves: ["earthquake", "protect", "quickattack", "return", "uturn", "wildcharge"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	fletchling: {
		tier: "LC",
	},
	fletchinder: {
		tier: "RU",
		doublesTier: "NFE",
	},
	talonflame: {
		randomBattleMoves: ["bravebird", "flareblitz", "roost", "swordsdance", "tailwind", "uturn", "willowisp"],
		randomDoubleBattleMoves: ["bravebird", "flareblitz", "protect", "roost", "swordsdance", "tailwind", "taunt", "uturn", "willowisp"],
		tier: "OU",
		doublesTier: "DOU",
	},
	scatterbug: {
		tier: "LC",
	},
	spewpa: {
		tier: "NFE",
	},
	vivillon: {
		randomBattleMoves: ["energyball", "hurricane", "quiverdance", "sleeppowder", "substitute"],
		randomDoubleBattleMoves: ["bugbuzz", "hurricane", "protect", "quiverdance", "roost", "sleeppowder"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	litleo: {
		tier: "LC",
	},
	pyroar: {
		randomBattleMoves: ["darkpulse", "fireblast", "hypervoice", "solarbeam", "sunnyday", "willowisp"],
		randomDoubleBattleMoves: ["fireblast", "hypervoice", "protect", "solarbeam", "sunnyday", "willowisp"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	flabebe: {
		tier: "LC",
	},
	floette: {
		tier: "NFE",
	},
	floetteeternal: {
		randomBattleMoves: ["hiddenpowerfire", "hiddenpowerground", "lightofruin", "moonblast", "psychic"],
		randomDoubleBattleMoves: ["aromatherapy", "calmmind", "dazzlinggleam", "lightofruin", "protect", "psychic", "wish"],
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	florges: {
		randomBattleMoves: ["aromatherapy", "calmmind", "moonblast", "protect", "synthesis", "toxic", "wish"],
		randomDoubleBattleMoves: ["aromatherapy", "calmmind", "dazzlinggleam", "moonblast", "protect", "psychic", "wish"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	skiddo: {
		tier: "LC",
	},
	gogoat: {
		randomBattleMoves: ["bulkup", "earthquake", "hornleech", "leechseed", "milkdrink", "rockslide", "substitute"],
		randomDoubleBattleMoves: ["brickbreak", "bulkup", "earthquake", "hornleech", "leechseed", "milkdrink", "protect", "rockslide"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	pancham: {
		tier: "LC",
	},
	pangoro: {
		randomBattleMoves: ["drainpunch", "gunkshot", "icepunch", "knockoff", "partingshot", "superpower"],
		randomDoubleBattleMoves: ["circlethrow", "crunch", "earthquake", "hammerarm", "icepunch", "partingshot", "poisonjab", "protect"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	furfrou: {
		randomBattleMoves: ["cottonguard", "rest", "return", "substitute", "suckerpunch", "thunderwave", "toxic", "uturn"],
		randomDoubleBattleMoves: ["cottonguard", "protect", "return", "snarl", "suckerpunch", "thunderwave", "uturn", "wildcharge"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	espurr: {
		tier: "LC",
	},
	meowstic: {
		randomBattleMoves: ["healbell", "lightscreen", "psychic", "reflect", "thunderwave", "toxic", "yawn"],
		randomDoubleBattleMoves: ["fakeout", "lightscreen", "protect", "psychic", "reflect", "safeguard", "thunderwave"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	meowsticf: {
		randomBattleMoves: ["calmmind", "energyball", "psychic", "psyshock", "shadowball", "thunderbolt"],
		randomDoubleBattleMoves: ["darkpulse", "energyball", "fakeout", "helpinghand", "protect", "psyshock", "signalbeam", "thunderbolt"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	honedge: {
		tier: "LC",
	},
	doublade: {
		randomBattleMoves: ["ironhead", "sacredsword", "shadowclaw", "shadowsneak", "swordsdance"],
		randomDoubleBattleMoves: ["ironhead", "protect", "rockslide", "sacredsword", "shadowclaw", "shadowsneak", "swordsdance"],
		tier: "UU",
		doublesTier: "NFE",
	},
	aegislash: {
		randomBattleMoves: ["flashcannon", "hiddenpowerice", "kingsshield", "shadowball", "shadowsneak"],
		randomDoubleBattleMoves: ["flashcannon", "hiddenpowerice", "kingsshield", "shadowball", "shadowsneak"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	aegislashblade: {
		randomBattleMoves: ["ironhead", "sacredsword", "shadowclaw", "shadowsneak", "swordsdance"],
		randomDoubleBattleMoves: ["ironhead", "kingsshield", "sacredsword", "shadowclaw", "shadowsneak", "swordsdance"],
	},
	spritzee: {
		tier: "LC",
	},
	aromatisse: {
		randomBattleMoves: ["aromatherapy", "moonblast", "protect", "toxic", "wish"],
		randomDoubleBattleMoves: ["aromatherapy", "healpulse", "moonblast", "protect", "thunderbolt", "trickroom", "wish"],
		tier: "RU",
		doublesTier: "DUU",
	},
	swirlix: {
		tier: "NFE",
	},
	slurpuff: {
		randomBattleMoves: ["bellydrum", "drainpunch", "playrough", "return"],
		randomDoubleBattleMoves: ["bellydrum", "dazzlinggleam", "drainpunch", "flamethrower", "playrough", "protect", "psychic", "return", "surf"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	inkay: {
		tier: "LC",
	},
	malamar: {
		randomBattleMoves: ["knockoff", "psychocut", "substitute", "superpower", "trickroom"],
		randomDoubleBattleMoves: ["knockoff", "protect", "psychocut", "rockslide", "superpower", "trickroom"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	binacle: {
		tier: "LC",
	},
	barbaracle: {
		randomBattleMoves: ["crosschop", "earthquake", "razorshell", "shellsmash", "stealthrock", "stoneedge"],
		randomDoubleBattleMoves: ["crosschop", "earthquake", "protect", "razorshell", "rockslide", "shellsmash"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	skrelp: {
		tier: "LC",
	},
	dragalge: {
		randomBattleMoves: ["dracometeor", "dragonpulse", "focusblast", "hiddenpowerfire", "scald", "sludgewave", "toxicspikes"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "focusblast", "hiddenpowerfire", "protect", "scald", "sludgebomb"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	clauncher: {
		tier: "LC",
	},
	clawitzer: {
		randomBattleMoves: ["aurasphere", "darkpulse", "icebeam", "scald", "uturn", "waterpulse"],
		randomDoubleBattleMoves: ["aurasphere", "darkpulse", "helpinghand", "icebeam", "muddywater", "protect", "uturn", "waterpulse"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	helioptile: {
		tier: "LC",
	},
	heliolisk: {
		randomBattleMoves: ["darkpulse", "hiddenpowerice", "hypervoice", "raindance", "surf", "thunderbolt", "voltswitch"],
		randomDoubleBattleMoves: ["darkpulse", "hiddenpowerice", "protect", "raindance", "surf", "thunder", "thunderbolt", "voltswitch"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	tyrunt: {
		tier: "LC",
	},
	tyrantrum: {
		randomBattleMoves: ["dragonclaw", "dragondance", "earthquake", "headsmash", "outrage", "stealthrock", "superpower"],
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "earthquake", "firefang", "headsmash", "icefang", "protect", "rockslide"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	amaura: {
		tier: "LC",
	},
	aurorus: {
		randomBattleMoves: ["ancientpower", "blizzard", "earthpower", "freezedry", "hypervoice", "stealthrock", "thunderwave"],
		randomDoubleBattleMoves: ["ancientpower", "flashcannon", "freezedry", "hypervoice", "icywind", "protect", "thunderwave"],
		tier: "NU",
		doublesTier: "(DUU)",
	},
	sylveon: {
		randomBattleMoves: ["calmmind", "hiddenpowerfire", "hypervoice", "protect", "psyshock", "wish"],
		randomDoubleBattleMoves: ["calmmind", "helpinghand", "hiddenpowerground", "hypervoice", "protect", "psyshock", "shadowball", "wish"],
		tier: "UU",
		doublesTier: "DOU",
	},
	hawlucha: {
		randomBattleMoves: ["acrobatics", "highjumpkick", "roost", "stoneedge", "substitute", "swordsdance"],
		randomDoubleBattleMoves: ["encore", "highjumpkick", "protect", "skydrop", "stoneedge", "swordsdance", "uturn"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	dedenne: {
		randomBattleMoves: ["grassknot", "hiddenpowerice", "nuzzle", "recycle", "substitute", "thunderbolt", "toxic"],
		randomDoubleBattleMoves: ["grassknot", "helpinghand", "hiddenpowerice", "nuzzle", "protect", "thunderbolt", "uturn", "voltswitch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	carbink: {
		randomBattleMoves: ["explosion", "lightscreen", "moonblast", "powergem", "reflect", "stealthrock"],
		randomDoubleBattleMoves: ["explosion", "lightscreen", "moonblast", "powergem", "protect", "reflect", "trickroom"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	goomy: {
		tier: "LC",
	},
	sliggoo: {
		tier: "NFE",
	},
	goodra: {
		randomBattleMoves: ["dracometeor", "dragontail", "earthquake", "fireblast", "powerwhip", "sludgebomb", "thunderbolt"],
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "fireblast", "focusblast", "icebeam", "muddywater", "protect", "thunderbolt"],
		tier: "UU",
		doublesTier: "DUU",
	},
	klefki: {
		randomBattleMoves: ["foulplay", "lightscreen", "playrough", "reflect", "spikes", "thunderwave", "toxic"],
		randomDoubleBattleMoves: ["dazzlinggleam", "flashcannon", "lightscreen", "playrough", "protect", "reflect", "safeguard", "substitute", "thunderwave"],
		tier: "UU",
		doublesTier: "(DUU)",
	},
	phantump: {
		tier: "LC",
	},
	trevenant: {
		randomBattleMoves: ["earthquake", "hornleech", "rest", "rockslide", "shadowclaw", "trickroom", "woodhammer"],
		randomDoubleBattleMoves: ["earthquake", "hornleech", "leechseed", "protect", "rockslide", "shadowclaw", "trickroom", "willowisp", "woodhammer"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pumpkaboo: {
		tier: "LC",
	},
	pumpkaboosmall: {
		tier: "LC",
	},
	pumpkaboolarge: {
		tier: "LC",
	},
	pumpkaboosuper: {
		tier: "LC",
	},
	gourgeist: {
		randomBattleMoves: ["leechseed", "seedbomb", "shadowsneak", "substitute", "synthesis", "willowisp"],
		randomDoubleBattleMoves: ["explosion", "leechseed", "painsplit", "phantomforce", "protect", "seedbomb", "shadowsneak", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gourgeistsmall: {
		randomBattleMoves: ["leechseed", "seedbomb", "shadowsneak", "substitute", "synthesis", "willowisp"],
		randomDoubleBattleMoves: ["explosion", "leechseed", "painsplit", "phantomforce", "protect", "seedbomb", "shadowsneak", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gourgeistlarge: {
		randomBattleMoves: ["leechseed", "seedbomb", "shadowsneak", "substitute", "synthesis", "willowisp"],
		randomDoubleBattleMoves: ["explosion", "leechseed", "painsplit", "phantomforce", "protect", "seedbomb", "shadowsneak", "trickroom", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
	},
	gourgeistsuper: {
		randomBattleMoves: ["leechseed", "seedbomb", "shadowsneak", "substitute", "synthesis", "willowisp"],
		randomDoubleBattleMoves: ["explosion", "leechseed", "painsplit", "phantomforce", "protect", "seedbomb", "shadowsneak", "trickroom", "willowisp"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	bergmite: {
		tier: "LC",
	},
	avalugg: {
		randomBattleMoves: ["avalanche", "earthquake", "rapidspin", "recover", "roar", "toxic"],
		randomDoubleBattleMoves: ["avalanche", "earthquake", "protect", "recover"],
		tier: "PU",
		doublesTier: "(DUU)",
	},
	noibat: {
		tier: "LC",
	},
	noivern: {
		randomBattleMoves: ["boomburst", "dracometeor", "flamethrower", "hurricane", "roost", "switcheroo", "taunt", "uturn"],
		randomDoubleBattleMoves: ["airslash", "boomburst", "dracometeor", "dragonpulse", "flamethrower", "focusblast", "hurricane", "protect", "roost", "switcheroo", "tailwind", "taunt", "uturn"],
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	xerneas: {
		randomBattleMoves: ["closecombat", "focusblast", "geomancy", "hiddenpowerfire", "moonblast", "psyshock", "thunderbolt"],
		randomDoubleBattleMoves: ["closecombat", "dazzlinggleam", "focusblast", "geomancy", "hiddenpowerfire", "protect", "psyshock", "rockslide", "thunder", "thunderbolt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	yveltal: {
		randomBattleMoves: ["darkpulse", "foulplay", "oblivionwing", "roost", "suckerpunch", "taunt", "toxic", "uturn"],
		randomDoubleBattleMoves: ["darkpulse", "focusblast", "hurricane", "oblivionwing", "protect", "roost", "skydrop", "snarl", "suckerpunch", "taunt"],
		tier: "Uber",
		doublesTier: "DUber",
	},
	zygarde: {
		randomBattleMoves: ["dragondance", "earthquake", "extremespeed", "glare", "outrage", "stoneedge"],
		randomDoubleBattleMoves: ["coil", "dragondance", "extremespeed", "glare", "landswrath", "protect", "rockslide", "stoneedge"],
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	diancie: {
		randomBattleMoves: ["diamondstorm", "earthpower", "hiddenpowerfire", "lightscreen", "moonblast", "reflect", "stealthrock"],
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "diamondstorm", "lightscreen", "moonblast", "protect", "psychic", "reflect", "safeguard", "substitute"],
		tier: "RU",
		doublesTier: "DUU",
	},
	dianciemega: {
		randomBattleMoves: ["calmmind", "diamondstorm", "earthpower", "hiddenpowerfire", "moonblast"],
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "diamondstorm", "earthpower", "hiddenpowerfire", "moonblast", "protect", "psyshock"],
		tier: "OU",
		doublesTier: "DOU",
	},
	hoopa: {
		randomBattleMoves: ["focusblast", "nastyplot", "psyshock", "shadowball", "trick"],
		randomDoubleBattleMoves: ["focusblast", "hyperspacehole", "protect", "psychic", "shadowball", "trickroom"],
		tier: "RU",
		doublesTier: "(DUU)",
	},
	hoopaunbound: {
		randomBattleMoves: ["darkpulse", "drainpunch", "focusblast", "gunkshot", "hyperspacefury", "nastyplot", "psychic", "substitute", "trick", "zenheadbutt"],
		randomDoubleBattleMoves: ["darkpulse", "drainpunch", "focusblast", "gunkshot", "hyperspacefury", "icepunch", "protect", "psychic", "zenheadbutt"],
		tier: "Uber",
		doublesTier: "DOU",
	},
	volcanion: {
		randomBattleMoves: ["earthpower", "fireblast", "hiddenpowerice", "sludgewave", "steameruption", "substitute", "superpower"],
		randomDoubleBattleMoves: ["earthquake", "heatwave", "protect", "rockslide", "sludgebomb", "steameruption", "substitute"],
		tier: "OU",
		doublesTier: "DOU",
	},
};
